import React, {Component, createRef} from 'react';
import '../../../../style/profilePage.css'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {Modal} from 'react-bootstrap';
import {AiOutlineClose} from 'react-icons/ai';
import {AiFillCloseCircle} from 'react-icons/ai';
import {Accordion} from 'react-bootstrap';
import {Table} from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import BuildingContext from "../../../../contexts/Building";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {Box, Button, CircularProgress, FormControl, MenuItem, Select} from "@mui/material";
import {green} from "@mui/material/colors";
import axios from "axios";
import ReactToPrint from "react-to-print";
import PrintInformation from "../../../PrintInformation";
import PrintReports from "../../../PrintReports";
import api, { API_BASE_URL } from '../../../../api/client';
import { formatDateObject, formatDatePart, displayOrUnset, addDaysToJalali, sumAmounts } from '../../../../utils/persianDate';
import DateObject from "react-date-object";

class ProfilePage extends Component {
    static contextType = BuildingContext;

    state = {
        dateValues: {
            cleaningDate: '',
            workReportDate: '',
            delayInArrivalDate: '',
            delayInArriveTime: '',
            exitStartDate: '',
            exitEndDate: '',
            violationDate: '',
            violationTime: '',
            dischargeDateAnnounce: '',
            dischargeDate: '',
            depositReturnDate: '',
            cancelContractDate: '',
        },
        person: {},
        show: false,
        reportType: 'cleaning',
        personObject: {},
        report: [],
        showDeleteModalReport: false,
        reportTemp: {},
        docFile: {},
        fileDetails: [],
        profileImgUrl: null,
        hasBirthPage1: false,
        hasBirthPage2: false,
        hasBirthPage3: false,
        hasBirthPage4: false,
        hasBirthAllPage: false,
        hasCartPage1: false,
        hasCartPage2: false,
        hasCartAllPage: false,
        hasPersonnelImg: false,
        hasRegister: false,
        hasRegisterUni: false,
        registerLoading: false,
        printLoading: false,
        residenceLocation: '',
        hasCommitmentLetter: false,
        commitmentUploadLoading: false,
        docUploadLoadingKey: '',
        bedInfo: null,
        editMode: false,
        editSaving: false,
        editDraft: {},
        editingWorkReport: null,
        showEditReturnModal: false,
        editReturnTemp: {},
        editReturnAmount: '',
        editReturnDate: '',
        showExtendBedModal: false,
        extendBedDateDraft: '',
        extendBedSaving: false,
        cleaningArchiveSearch: '',
        pageLoading: true,
        secondaryLoading: false,
    }
    date = createRef();
    description = createRef();
    time = createRef();
    startDate = createRef();
    endDate = createRef();
    destinationAddress = createRef();
    destinationPhoneNumber = createRef();
    relation = createRef();
    typePenalty = createRef();
    dischargeDateAnnounce = createRef();
    dischargeDate = createRef();
    depositReturnDate = createRef();
    deductionOfLosses = createRef();
    deductionOfLossesReason = createRef();
    refundableAmount = createRef();
    reason = createRef();
    penaltyAmount = createRef();
    component1Ref = createRef()
    component2Ref = createRef()

    async componentDidMount() {
        const path = window.location.pathname;
        const personId = path.substring(path.lastIndexOf('/') + 1).slice(0, 32);
        const editMode = new URLSearchParams(window.location.search).get('edit') === '1';
        this.setState({editMode, pageLoading: true, secondaryLoading: true});

        try {
            const data = await api.get(`/api/v1/supervisor/characteristic/${personId}`).then(r => r.data);
            if (!data) {
                this.setState({pageLoading: false, secondaryLoading: false});
                return;
            }
            // Show header/content ASAP — secondary data loads in parallel without blocking UI
            this.setState({
                person: data,
                editDraft: this.buildEditDraft(data),
                pageLoading: false,
            });
            await this.loadSecondaryProfileData(data.parentId, data.profileId);
        } catch (e) {
            this.setState({pageLoading: false, secondaryLoading: false});
        }
    }

    loadSecondaryProfileData = async (parentId, profileId) => {
        const tasks = [];

        if (parentId) {
            tasks.push((async () => {
                try {
                    const personData = await api.get(`/api/v1/supervisor/person/${parentId}`).then(r => r.data);
                    const files = personData?.files || {};
                    const records = Array.isArray(personData?.record) ? personData.record : [];
                    this.setState({
                        personObject: personData || {},
                        docFile: files,
                        report: records,
                    });
                    this.existDocFile(files);
                    if (personData?.bed) {
                        // don't block other secondary loads
                        this.loadResidenceLocation(personData.bed).catch(() => {});
                    }
                } catch (e) { /* keep empty */ }
            })());

            tasks.push((async () => {
                try {
                    const fileDetails = await api.get(
                        `/api/v1/supervisor/responseFile/search?parentType=Person&parentId=${parentId}`
                    ).then(r => r.data);
                    this.setState({fileDetails: Array.isArray(fileDetails) ? fileDetails : []});
                } catch (e) { /* keep empty */ }
            })());
        }

        if (profileId) {
            tasks.push((async () => {
                try {
                    const blob = await api.get(`/api/v1/supervisor/file/${profileId}`, {
                        responseType: 'blob',
                    }).then(r => r.data);
                    if (blob) {
                        this.setState({profileImgUrl: URL.createObjectURL(blob)});
                    }
                } catch (e) { /* default avatar */ }
            })());
        }

        await Promise.all(tasks);
        this.setState({secondaryLoading: false});
    }

    loadResidenceLocation = async (bedId) => {
        try {
            const bed = await api.get(`/api/v1/supervisor/bed/${bedId}`).then(r => r.data);
            const room = await api.get(`/api/v1/supervisor/room/${bed.room}`).then(r => r.data);
            const unit = await api.get(`/api/v1/supervisor/unit/${room.unit}`).then(r => r.data);
            let floorLabel = unit.floor;
            try {
                const floor = await api.get(`/api/v1/supervisor/floor/${unit.floor}`).then(r => r.data);
                floorLabel = floor.name || floorLabel;
            } catch (e) { /* keep id */ }
            const location = `طبقه ${floorLabel} / واحد ${unit.number} / اتاق ${room.number} / تخت ${bed.name}`;
            this.setState({
                residenceLocation: location,
                bedInfo: {
                    id: bed.id || bedId,
                    name: bed.name,
                    empty: bed.empty,
                    roomId: bed.room,
                    personId: bed.person || this.state.personObject?.id,
                },
            });
        } catch (e) {
            this.setState({residenceLocation: 'ثبت نشده', bedInfo: null});
        }
    }

    getCleaningStats = () => {
        const cleaning = (this.state.report || []).filter((r) => r.title === 'cleaning');
        const total = sumAmounts(cleaning);
        const now = new DateObject({calendar: persian, locale: persian_fa});
        const ym = `${now.year}/${String(now.month.number).padStart(2, '0')}`;
        const thisMonth = cleaning.filter((r) => String(r.date || '').startsWith(ym));
        return {
            count: cleaning.length,
            total,
            monthCount: thisMonth.length,
            monthTotal: sumAmounts(thisMonth),
        };
    }

    matchesCleaningArchiveSearch = (record) => {
        const q = (this.state.cleaningArchiveSearch || '').trim().toLowerCase();
        if (!q) {
            return true;
        }
        const haystack = `${record.date || ''} ${record.description || ''} ${record.penaltyAmount || ''}`.toLowerCase();
        return haystack.includes(q);
    }

    getLatestDischargeDeadline = () => {
        const discharges = (this.state.report || []).filter((r) => r.title === 'discharge');
        if (!discharges.length) {
            return null;
        }
        const latest = discharges[discharges.length - 1];
        const base = latest.endDate || latest.date;
        const deadline = addDaysToJalali(base, 45, DateObject, persian, persian_fa);
        return {dischargeDate: base, deadline45: deadline, phone: this.state.person?.phoneNumber};
    }

    renameBed = async () => {
        const info = this.state.bedInfo;
        if (!info?.id) {
            window.alert('تختی برای این اقامتگر ثبت نشده');
            return;
        }
        const nextName = window.prompt('کد/نام جدید تخت', info.name || '');
        if (nextName == null) {
            return;
        }
        const name = String(nextName).trim();
        if (!name) {
            return;
        }
        const payload = {
            name,
            empty: info.empty === true || info.empty === 'true',
            roomId: info.roomId,
            personId: info.personId || this.state.personObject?.id,
        };
        await axios.put(`${API_BASE_URL}/api/v1/supervisor/bed/${info.id}`, payload, {
            headers: {'Authorization': localStorage.getItem('accessToken')}
        }).then(() => {
            this.setState({bedInfo: {...info, name}});
            this.loadResidenceLocation(info.id);
            window.alert('کد تخت به‌روز شد');
        }).catch(() => window.alert('به‌روزرسانی تخت ناموفق بود'));
    }

    openEditReturn = (record) => {
        this.setState({
            showEditReturnModal: true,
            editReturnTemp: record,
            editReturnAmount: record.returnedAmount || '',
            editReturnDate: record.date || '',
        });
    }

    saveEditReturn = async () => {
        const rec = this.state.editReturnTemp;
        if (!rec?.id) {
            return;
        }
        const payload = {
            title: rec.title,
            returnedAmount: this.state.editReturnAmount,
            date: this.state.editReturnDate,
            personId: this.state.personObject?.id,
        };
        await axios.put(`${API_BASE_URL}/api/v1/supervisor/record/${rec.id}`, payload, {
            headers: {'Authorization': localStorage.getItem('accessToken')}
        }).then((response) => {
            const updated = response.data || {...rec, ...payload};
            const report = (this.state.report || []).map((r) => r.id === rec.id ? {...r, ...updated} : r);
            this.setState({report, showEditReturnModal: false, editReturnTemp: {}});
        }).catch(() => window.alert('ویرایش عودت ناموفق بود'));
    }

    render() {
        if (this.state.pageLoading) {
            return (
                <div
                    className="d-flex flex-column align-items-center justify-content-center px-3"
                    style={{minHeight: '55vh'}}
                    role="status"
                    aria-live="polite"
                >
                    <CircularProgress size={42}/>
                    <div className="mt-3 text-muted" style={{fontSize: '0.95rem'}}>
                        در حال بارگذاری اطلاعات اقامتگر...
                    </div>
                </div>
            );
        }

        return (
            <>
                <div className="px-3 mb-5">
                    {this.state.secondaryLoading ? (
                        <div className="d-flex align-items-center justify-content-center gap-2 mb-2 text-muted" style={{fontSize: '0.85rem'}}>
                            <CircularProgress size={16}/>
                            <span>در حال تکمیل مدارک و موقعیت اقامت...</span>
                        </div>
                    ) : null}
                    <div className="d-flex flex-column container">
                        <div className="d-flex flex-row justify-content-center profile-card">
                            <div className={'d-flex flex-md-row flex-column align-items-center'}>
                                <img
                                    src={this.state.profileImgUrl !== null ? (this.state.profileImgUrl) : ("https://cdn-icons-png.flaticon.com/512/149/149071.png")}
                                    alt="profile"/>
                                <div className={'me-3 d-flex flex-column justify-content-center'}>
                                    <div
                                        className="people-name mb-3">{this.state.person.firstName} {this.state.person.lastName}</div>
                                    <div className="d-flex flex-md-row flex-column flex-wrap">
                                        <div className="people-item"><i className="bi bi-upc-scan ms-2"></i>کد
                                            ملی: {this.state.person.nationalCode}</div>
                                        <div className="people-item"><i className="bi bi-telephone ms-2"></i>شماره
                                            تماس: {this.state.person.phoneNumber}</div>
                                        <div className="people-item"><i className="bi bi-person ms-2"></i>نام
                                            پدر: {this.state.person.fatherName}</div>
                                        <div className="people-item">
                                            <i className="bi bi-person ms-2"></i>
                                            نوع اقامتگر:
                                            {(() => {
                                                switch (this.state.person.personType) {
                                                    case 'constant':
                                                        return 'اقامتگر ثابت';
                                                    case 'familyGuest':
                                                        return 'بستگان درجه یک';
                                                    case 'otherGuest':
                                                        return 'متفرقه';
                                                }
                                            })()}
                                        </div>
                                        <div className="people-item">
                                            <i className="bi bi-house-door ms-2"></i>
                                            موقعیت اقامت:
                                            {this.state.residenceLocation || 'ثبت نشده'}
                                            {this.state.bedInfo?.id ? (
                                                <button type="button" className="btn btn-link btn-sm p-0 me-2"
                                                        onClick={this.renameBed}>ویرایش کد تخت</button>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab">
                            <Tabs
                                defaultActiveKey="more-information"
                                id="uncontrolled-tab-example"
                                className="border-0 w-100"
                            >
                                <Tab eventKey="more-information" title="اطلاعات بیشتر"
                                     style={{backgroundColor: "transparent"}}>
                                    <div className="tabs-content">
                                        {this.state.editMode ? (
                                            <div className="mb-4 p-3 border rounded" style={{background: '#fff'}}>
                                                <h6 className="mb-3">ویرایش مشخصات</h6>
                                                {this.renderPersonEditFields()}

                                                <div className="mt-3 d-flex gap-2">
                                                    <button type="button" className="btn btn-success btn-sm"
                                                            disabled={this.state.editSaving}
                                                            onClick={this.savePersonEdit}>ذخیره</button>
                                                    <button type="button" className="btn btn-light btn-sm"
                                                            onClick={() => this.setState({
                                                                editMode: false,
                                                                editDraft: this.buildEditDraft(this.state.person),
                                                            })}>انصراف</button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="d-flex justify-content-end mb-2">
                                                <button type="button" className="btn btn-outline-primary btn-sm"
                                                        onClick={() => this.setState({
                                                            editMode: true,
                                                            editDraft: this.buildEditDraft(this.state.person),
                                                        })}>ویرایش مشخصات</button>
                                            </div>
                                        )}
                                        <div className={"d-flex justify-content-end"}>
                                            <ReactToPrint
                                                trigger={() =>
                                                    <Button
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: "#DB9B31",
                                                            color: "white",
                                                            ":hover": {backgroundColor: "#DB9B31", color: "black"}
                                                        }}
                                                        disabled={this.state.printLoading}
                                                    >
                                                        چاپ اطلاعات
                                                    </Button>
                                            }
                                                documentTitle={this.state.person.fullName}
                                                content={() => this.component1Ref.current}
                                            />
                                            <div style={{display: "none"}}>
                                                <PrintInformation person={this.state.person} ref={this.component1Ref} />
                                            </div>
                                        </div>
                                        {(() => {
                                            switch (this.state.person.personType) {
                                                case 'constant':
                                                    return <>
                                                        <div className="information d-flex flex-row flex-wrap">
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام :</label>
                                                                    {this.state.person.firstName}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام خانوادگی :</label>
                                                                    {this.state.person.lastName}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> کد ملی :</label>
                                                                    {this.state.person.nationalCode}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره شناسنامه :</label>
                                                                    {this.state.person.certificateNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> محل صدور :</label>
                                                                    {this.state.person.placeOfIssue}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ تولد :</label>
                                                                    {formatDatePart(this.state.person.birthDate)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> ملیت :</label>
                                                                    {this.state.person.nationality}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام پدر :</label>
                                                                    {this.state.person.fatherName}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> دین :</label>
                                                                    {(() => {
                                                                        switch (this.state.person.religion) {
                                                                            case 'islam':
                                                                                return 'اسلام';
                                                                            case 'christianity':
                                                                                return 'مسیحیت';
                                                                            case 'hinduism':
                                                                                return 'هندوئیسم';
                                                                            case 'buddhism':
                                                                                return 'آیین بودایی';
                                                                            case 'other':
                                                                                return 'سایر';
                                                                        }
                                                                    })()}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> مذهب :</label>
                                                                    {displayOrUnset(this.state.person.subReligion)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> دانشگاه محل تحصیل :</label>
                                                                    {displayOrUnset(this.state.person.university)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تحصیلات :</label>
                                                                    {this.state.person.education ? this.state.person.education : 'ثبت نشده'}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره دانشجویی :</label>
                                                                    {displayOrUnset(this.state.person.studentNumber)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شغل پدر :</label>
                                                                    {displayOrUnset(this.state.person.fatherJob)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> وضعیت تاهل :</label>
                                                                    {(() => {
                                                                        switch (this.state.person.maritalStatus) {
                                                                            case 'single':
                                                                                return 'مجرد';
                                                                            case 'married':
                                                                                return 'متاهل';
                                                                            case 'divorced':
                                                                                return 'متارکه';
                                                                        }
                                                                    })()}
                                                                </div>
                                                            </div>
                                                            {(() => {
                                                                switch (this.state.person.maritalStatus) {
                                                                    case 'married':
                                                                        return <>
                                                                            <div className='col-12 col-md-4'>
                                                                                <div className="more-info-item">
                                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                                    <label> نام و نام خانوادگی همسر
                                                                                        :</label>
                                                                                    {displayOrUnset(this.state.person.spouseFullName)}
                                                                                </div>
                                                                            </div>
                                                                            <div className='col-12 col-md-4'>
                                                                                <div className="more-info-item">
                                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                                    <label> شغل همسر :</label>
                                                                                    {displayOrUnset(this.state.person.spouseJob)}
                                                                                </div>
                                                                            </div>
                                                                        </>;
                                                                }
                                                            })()}
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> بیماری خاص :</label>
                                                                    {(() => {
                                                                        switch (this.state.person.health) {
                                                                            case true:
                                                                                return 'بله';
                                                                            case false:
                                                                                return 'خیر';
                                                                        }
                                                                    })()}
                                                                </div>
                                                            </div>
                                                            {(() => {
                                                                switch (this.state.person.health) {
                                                                    case true:
                                                                        return <>
                                                                            <div className='col-12 col-md-4'>
                                                                                <div className="more-info-item">
                                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                                    <label> توضیحات بیماری :</label>
                                                                                    {displayOrUnset(this.state.person.healthyStatus)}
                                                                                </div>
                                                                            </div>
                                                                        </>;
                                                                }
                                                            })()}
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره همراه اقامتگر :</label>
                                                                    {this.state.person.phoneNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره تلفن منزل :</label>
                                                                    {this.state.person.telephoneNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ شروع پذیرش :</label>
                                                                    {formatDatePart(this.state.person.timePeriod?.startDate)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ اتمام پذیرش :</label>
                                                                    {formatDatePart(this.state.person.timePeriod?.endDate)}
                                                                    {this.state.person.timePeriod?.endDate ? (
                                                                        <button type="button" className="btn btn-sm btn-outline-success ms-2"
                                                                                onClick={this.openExtendBedModal}>
                                                                            تمدید تخت
                                                                        </button>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> آدرس محل سکونت :</label>
                                                                    {this.state.person.address}
                                                                </div>
                                                            </div>
                                                            <div className="col-12 my-2 me-3"
                                                                 style={{fontSize: '.9rem', fontWeight: '600'}}>مشخصات
                                                                بستگان(شخص اول)
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام و نام خانوادگی :</label>
                                                                    {this.state.person.firstPersonFullName}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره تماس :</label>
                                                                    {this.state.person.firstPersonPhoneNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام پدر :</label>
                                                                    {displayOrUnset(this.state.person.firstPersonFatherName)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نسبت با اقامتگر :</label>
                                                                    {(() => {
                                                                        switch (this.state.person.firstPersonRelationshipWithResident) {
                                                                            case 'father':
                                                                                return 'پدر';
                                                                            case 'mother':
                                                                                return 'مادر';
                                                                            case 'sister':
                                                                                return 'خواهر';
                                                                            case 'brother':
                                                                                return 'برادر';
                                                                            case 'other':
                                                                                return 'غیره';
                                                                        }
                                                                    })()}
                                                                </div>
                                                            </div>
                                                            <div className="col-12 my-2 me-3"
                                                                 style={{fontSize: '.9rem', fontWeight: '600'}}>مشخصات
                                                                بستگان(شخص دوم)
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام و نام خانوادگی :</label>
                                                                    {this.state.person.secondPersonFullName}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره تماس :</label>
                                                                    {this.state.person.secondPersonPhoneNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام پدر :</label>
                                                                    {displayOrUnset(this.state.person.secondPersonFatherName)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نسبت با اقامتگر :</label>
                                                                    {(() => {
                                                                        switch (this.state.person.secondPersonRelationshipWithResident) {
                                                                            case 'father':
                                                                                return 'پدر';
                                                                            case 'mother':
                                                                                return 'مادر';
                                                                            case 'sister':
                                                                                return 'خواهر';
                                                                            case 'brother':
                                                                                return 'برادر';
                                                                            case 'other':
                                                                                return 'غیره';
                                                                        }
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>;
                                                case 'familyGuest':
                                                    return <>
                                                        <div className="information d-flex flex-row flex-wrap">
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام :</label>
                                                                    {this.state.person.firstName}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام خانوادگی :</label>
                                                                    {this.state.person.lastName}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نسبت با اقامتگر :</label>
                                                                    {(() => {
                                                                        switch (this.state.person.relationshipWithResident) {
                                                                            case 'father':
                                                                                return 'پدر';
                                                                            case 'mother':
                                                                                return 'مادر';
                                                                            case 'sister':
                                                                                return 'خواهر';
                                                                            case 'brother':
                                                                                return 'برادر';
                                                                            case 'other':
                                                                                return 'غیره';
                                                                        }
                                                                    })()}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> کد ملی :</label>
                                                                    {this.state.person.nationalCode}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره شناسنامه :</label>
                                                                    {this.state.person.certificateNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> محل صدور :</label>
                                                                    {displayOrUnset(this.state.person.placeOfIssue)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ تولد :</label>
                                                                    {formatDatePart(this.state.person.birthDate)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ شروع پذیرش :</label>
                                                                    {formatDatePart(this.state.person.timePeriod?.startDate)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ اتمام پذیرش :</label>
                                                                    {formatDatePart(this.state.person.timePeriod?.endDate)}
                                                                    {this.state.person.timePeriod?.endDate ? (
                                                                        <button type="button" className="btn btn-sm btn-outline-success ms-2"
                                                                                onClick={this.openExtendBedModal}>
                                                                            تمدید تخت
                                                                        </button>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ پرداخت :</label>
                                                                    {formatDatePart(this.state.person.paymentDate)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> مبلغ پرداخت اجاره :</label>
                                                                    {displayOrUnset(this.state.person.depositPaymentAmount)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> مبلغ پرداخت ودیعه :</label>
                                                                    {displayOrUnset(this.state.person.rentPaymentAmount)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> مبلغ پرداخت اجاره :</label>
                                                                    {displayOrUnset(this.state.person.discountPaymentAmount)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> آدرس محل سکونت :</label>
                                                                    {this.state.person.address}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره همراه اقامتگر :</label>
                                                                    {this.state.person.phoneNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره تلفن منزل :</label>
                                                                    {this.state.person.telephoneNumber}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>;
                                                case 'otherGuest':
                                                    return <>
                                                        <div className="information d-flex flex-row flex-wrap">
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام :</label>
                                                                    {this.state.person.firstName}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نام خانوادگی :</label>
                                                                    {this.state.person.lastName}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> نسبت با اقامتگر :</label>
                                                                    {(() => {
                                                                        switch (this.state.person.relationshipWithResident) {
                                                                            case 'father':
                                                                                return 'پدر';
                                                                            case 'mother':
                                                                                return 'مادر';
                                                                            case 'sister':
                                                                                return 'خواهر';
                                                                            case 'brother':
                                                                                return 'برادر';
                                                                            case 'other':
                                                                                return 'غیره';
                                                                        }
                                                                    })()}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> کد ملی :</label>
                                                                    {this.state.person.nationalCode}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره شناسنامه :</label>
                                                                    {this.state.person.certificateNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> محل صدور :</label>
                                                                    {displayOrUnset(this.state.person.placeOfIssue)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ تولد :</label>
                                                                    {formatDatePart(this.state.person.birthDate)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ شروع پذیرش :</label>
                                                                    {formatDatePart(this.state.person.timePeriod?.startDate)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ اتمام پذیرش :</label>
                                                                    {formatDatePart(this.state.person.timePeriod?.endDate)}
                                                                    {this.state.person.timePeriod?.endDate ? (
                                                                        <button type="button" className="btn btn-sm btn-outline-success ms-2"
                                                                                onClick={this.openExtendBedModal}>
                                                                            تمدید تخت
                                                                        </button>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> تاریخ پرداخت :</label>
                                                                    {formatDatePart(this.state.person.paymentDate)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> مبلغ پرداخت اجاره :</label>
                                                                    {displayOrUnset(this.state.person.depositPaymentAmount)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> مبلغ پرداخت ودیعه :</label>
                                                                    {displayOrUnset(this.state.person.rentPaymentAmount)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> مبلغ پرداخت اجاره :</label>
                                                                    {displayOrUnset(this.state.person.discountPaymentAmount)}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> آدرس محل سکونت :</label>
                                                                    {this.state.person.address}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره همراه اقامتگر :</label>
                                                                    {this.state.person.phoneNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className="more-info-item">
                                                                    <i className="bi bi-caret-left ms-1"></i>
                                                                    <label> شماره تلفن منزل :</label>
                                                                    {this.state.person.telephoneNumber}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>;
                                            }
                                        })()}
                                    </div>
                                </Tab>
                                <Tab eventKey="records" title="سوابق" style={{backgroundColor: "transparent"}}>
                                    <div className="tabs-content">
                                        <div className={"d-flex justify-content-between flex-sm-row flex-column-reverse"}>
                                            <button className='btn-done mx-3' onClick={() => {
                                                this.handleShow()
                                                this.handleResetFields();
                                            }}>ثبت گزارش
                                            </button>
                                            <ReactToPrint
                                                trigger={() =>
                                                    <Button
                                                        className={"mx-3 mb-4"}
                                                        variant="contained"
                                                        sx={{
                                                            height: "80%",
                                                            backgroundColor: "#DB9B31",
                                                            color: "white",
                                                            ":hover": {backgroundColor: "#DB9B31", color: "black"}
                                                        }}
                                                        disabled={this.state.printLoading}
                                                    >
                                                        چاپ سوابق
                                                    </Button>
                                                }
                                                documentTitle={`سوابق ${this.state.person.fullName}`}
                                                content={() => this.component2Ref.current}
                                            />
                                            <div style={{display: "none"}}>
                                                <PrintReports
                                                    report={(this.state.report || []).map((r) => ({
                                                        ...r,
                                                        personType: r.personType || this.state.person?.personType,
                                                    }))}
                                                    personName={this.state.person?.fullName}
                                                    residenceStatusFilter={this.state.person?.personType || ''}
                                                    ref={this.component2Ref}
                                                />
                                            </div>
                                        </div>
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>نوبت نظافت شبانه</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="search-input-wrap mb-3">
                                                        <i className="bi bi-search" aria-hidden="true"/>
                                                        <input type="text" className="form-control form-control-sm"
                                                               placeholder="جستجو در توضیحات یا تاریخ..."
                                                               value={this.state.cleaningArchiveSearch}
                                                               onChange={(e) => this.setState({cleaningArchiveSearch: e.target.value})}/>
                                                    </div>
                                                    {(() => {
                                                        const stats = this.getCleaningStats();
                                                        return (
                                                            <div className="mb-3 text-muted small">
                                                                تعداد کل: {stats.count} | جمع مبالغ: {stats.total || 0}
                                                                {' '}| این ماه: {stats.monthCount} نوبت / {stats.monthTotal || 0}
                                                            </div>
                                                        );
                                                    })()}
                                                    <Table>
                                                        <thead>
                                                        <tr>
                                                            {/*<th>شماره</th>*/}
                                                            <th>تاریخ</th>
                                                            <th>مبلغ</th>
                                                            <th>توضیحات</th>
                                                            <th>عملیات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            (this.state.report || []).map((c, i) => (
                                                                c.title === 'cleaning' && this.matchesCleaningArchiveSearch(c) ? (
                                                                    <tr key={c.id || i}>
                                                                        {/*<td>{a+1}</td>*/}
                                                                        <td>{c.date}</td>
                                                                        <td>{c.penaltyAmount || '—'}</td>
                                                                        <td>{c.description}</td>
                                                                        <td>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="deleteTooltip">
                                                                                        حذف
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <button className='btn floor-close-btn'
                                                                                        onClick={() => this.handleOpenModalReport(c)}>
                                                                                    <AiFillCloseCircle color="#F1416C"/>
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ) : null
                                                            ))
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header>تأخیر در ورود</Accordion.Header>
                                                <Accordion.Body>
                                                    <Table>
                                                        <thead>
                                                        <tr>
                                                            {/*<th>شماره</th>*/}
                                                            <th>تاریخ</th>
                                                            <th>ساعت</th>
                                                            <th>عملیات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            (this.state.report || []).map((d, i) => (

                                                                d.title === 'delayInArrival' ? (
                                                                    <tr>
                                                                        {/*<td>{i+1}</td>*/}
                                                                        <td>{d.date}</td>
                                                                        <td>{d.hour}</td>
                                                                        <td>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="deleteTooltip">
                                                                                        حذف
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <button className='btn floor-close-btn'
                                                                                        onClick={() => this.handleOpenModalReport(d)}>
                                                                                    <AiFillCloseCircle color="#F1416C"/>
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    console.log()
                                                                )
                                                            ))
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header>خروج</Accordion.Header>
                                                <Accordion.Body>
                                                    <Table>
                                                        <thead>
                                                        <tr>
                                                            {/*<th>شماره</th>*/}
                                                            <th>از تاريخ</th>
                                                            <th>تا تاريخ</th>
                                                            <th>آدرس مقصد</th>
                                                            <th>شماره تماس مقصد</th>
                                                            <th>نسبت</th>
                                                            <th>عملیات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            (this.state.report || []).map((e, i) => (

                                                                (e.title === 'exit' || e.title === 'exitSecondary') ? (
                                                                    <tr>
                                                                        {/*<td>{i+1}</td>*/}
                                                                        <td>{e.startDate}</td>
                                                                        <td>{e.endDate}</td>
                                                                        <td>{e.destinationAddress}</td>
                                                                        <td>{e.destinationPhoneNumber}</td>
                                                                        <td>{e.relation}</td>
                                                                        <td>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="deleteTooltip">
                                                                                        حذف
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <button className='btn floor-close-btn'
                                                                                        onClick={() => this.handleOpenModalReport(e)}>
                                                                                    <AiFillCloseCircle color="#F1416C"/>
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    console.log()
                                                                )
                                                            ))
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="3">
                                                <Accordion.Header>ثبت تخلف</Accordion.Header>
                                                <Accordion.Body>
                                                    <Table>
                                                        <thead>
                                                        <tr>
                                                            {/*<th>شماره</th>*/}
                                                            <th>گزارش تخلف</th>
                                                            <th>تاریخ</th>
                                                            <th>ساعت</th>
                                                            <th>عملیات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            (this.state.report || []).map((v, i) => (

                                                                v.title === 'violation' ? (
                                                                    <tr>
                                                                        {/*<td>{i+1}</td>*/}
                                                                        <td>{v.description}</td>
                                                                        <td>{v.date}</td>
                                                                        <td>{v.hour}</td>
                                                                        <td>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="deleteTooltip">
                                                                                        حذف
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <button className='btn floor-close-btn'
                                                                                        onClick={() => this.handleOpenModalReport(v)}>
                                                                                    <AiFillCloseCircle color="#F1416C"/>
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    console.log()
                                                                )
                                                            ))
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="4">
                                                <Accordion.Header>ثبت جریمه</Accordion.Header>
                                                <Accordion.Body>
                                                    <Table>
                                                        <thead>
                                                        <tr>
                                                            {/*<th>شماره</th>*/}
                                                            <th>نوع جریمه</th>
                                                            <th>مقدار جریمه</th>
                                                            <th>دلیل جریمه</th>
                                                            <th>عملیات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            (this.state.report || []).map((p, i) => (

                                                                p.title === 'penalty' ? (
                                                                    <tr>
                                                                        <td>{p.penaltyType === "financial" ? ("نقدی") : ("تنبیهی")}</td>
                                                                        <td>{p.penaltyAmount}</td>
                                                                        <td>{p.description}</td>
                                                                        <td>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="deleteTooltip">
                                                                                        حذف
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <button className='btn floor-close-btn'
                                                                                        onClick={() => this.handleOpenModalReport(p)}>
                                                                                    <AiFillCloseCircle color="#F1416C"/>
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    console.log()
                                                                )
                                                            ))
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="5">
                                                <Accordion.Header>اعلام تخلیه</Accordion.Header>
                                                <Accordion.Body>
                                                    {(() => {
                                                        const d = this.getLatestDischargeDeadline();
                                                        if (!d) return null;
                                                        return (
                                                            <div className="mb-3 small">
                                                                مهلت ۴۵ روز پس از تخلیه ({d.dischargeDate}): <strong>{d.deadline45 || '—'}</strong>
                                                                {d.phone ? ` | تلفن: ${d.phone}` : ''}
                                                            </div>
                                                        );
                                                    })()}
                                                    <Table>
                                                        <thead>
                                                        <tr>
                                                            {/*<th>شماره</th>*/}
                                                            <th>نام اقامتگر</th>
                                                            <th>تاریخ اعلام تخلیه</th>
                                                            <th>تاریخ تخلیه</th>
                                                            <th>تاریخ عودت ودیعه</th>
                                                            <th>کسر ضرر و زیان</th>
                                                            <th>علت کسر ضر و زیان</th>
                                                            <th>مبلغ قابل عودت</th>
                                                            <th>عملیات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            (this.state.report || []).map((d, i) => (

                                                                d.title === 'discharge' ? (
                                                                    <tr>
                                                                        {/*<td>{i+1}</td>*/}
                                                                        <td>{this.state.person?.fullName || d.guestName || ''}</td>
                                                                        <td>{d.startDate}</td>
                                                                        <td>{d.endDate}</td>
                                                                        <td>{d.date}</td>
                                                                        <td>{d.penaltyAmount}</td>
                                                                        <td>{d.description}</td>
                                                                        <td>{d.returnedAmount}</td>
                                                                        <td>
                                                                            <button type="button" className="btn btn-sm btn-outline-primary me-1"
                                                                                    onClick={() => this.openEditReturn(d)}>ویرایش عودت</button>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="deleteTooltip">
                                                                                        حذف
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <button className='btn floor-close-btn'
                                                                                        onClick={() => this.handleOpenModalReport(d)}>
                                                                                    <AiFillCloseCircle color="#F1416C"/>
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    console.log()
                                                                )
                                                            ))
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="6">
                                                <Accordion.Header>لغو قرارداد</Accordion.Header>
                                                <Accordion.Body>
                                                    <Table>
                                                        <thead>
                                                        <tr>
                                                            {/*<th>شماره</th>*/}
                                                            <th>نام اقامتگر</th>
                                                            <th>تاریخ</th>
                                                            <th>علت</th>
                                                            <th>کسر ضرر و زیان</th>
                                                            <th>مبلغ قابل عودت</th>
                                                            <th>عملیات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            (this.state.report || []).map((cc, i) => (

                                                                cc.title === 'cancelContract' ? (
                                                                    <tr>
                                                                        {/*<td>{i+1}</td>*/}
                                                                        <td>{this.state.person?.fullName || cc.guestName || ''}</td>
                                                                        <td>{cc.date}</td>
                                                                        <td>{cc.description}</td>
                                                                        <td>{cc.penaltyAmount}</td>
                                                                        <td>{cc.returnedAmount}</td>
                                                                        <td>
                                                                            <button type="button" className="btn btn-sm btn-outline-primary me-1"
                                                                                    onClick={() => this.openEditReturn(cc)}>ویرایش عودت</button>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="deleteTooltip">
                                                                                        حذف
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <button className='btn floor-close-btn'
                                                                                        onClick={() => this.handleOpenModalReport(cc)}>
                                                                                    <AiFillCloseCircle color="#F1416C"/>
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    console.log()
                                                                )
                                                            ))
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="7">
                                                <Accordion.Header>گزارش کار روزانه</Accordion.Header>
                                                <Accordion.Body>
                                                    <Table>
                                                        <thead>
                                                        <tr>
                                                            <th>تاریخ</th>
                                                            <th>شرح</th>
                                                            <th>عملیات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            (this.state.report || []).map((w) => (
                                                                w.title === 'workReport' ? (
                                                                    <tr key={w.id}>
                                                                        <td>{w.date}</td>
                                                                        <td>{w.description}</td>
                                                                        <td>
                                                                            <button type="button" className="btn btn-sm btn-outline-primary me-1"
                                                                                    onClick={() => this.openEditWorkReport(w)}>ویرایش</button>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="deleteTooltip">
                                                                                        حذف
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <button className='btn floor-close-btn'
                                                                                        onClick={() => this.handleOpenModalReport(w)}>
                                                                                    <AiFillCloseCircle color="#F1416C"/>
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ) : null
                                                            ))
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </Tab>
                                <Tab eventKey="documents" title="مدارک" className='records'
                                     style={{backgroundColor: "transparent"}}>
                                    <div className="tabs-content">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>شناسنامه</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="d-flex flex-column">
                                                        {this.renderPersonDocRow('birthPage1', 'صفحه اول')}
                                                        {this.renderPersonDocRow('birthPage2', 'صفحه دوم')}
                                                        {this.renderPersonDocRow('birthPage3', 'صفحه سوم')}
                                                        {this.renderPersonDocRow('birthPage4', 'صفحه چهارم')}
                                                        {this.renderPersonDocRow('birthAllPage', 'کل صفحات')}
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header>کارت ملی</Accordion.Header>
                                                <Accordion.Body>
                                                    {this.renderPersonDocRow('cardPage1', 'صفحه اول')}
                                                    {this.renderPersonDocRow('cardPage2', 'صفحه دوم')}
                                                    {this.renderPersonDocRow('cardAllPage', 'کل صفحات')}
                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header>عکس پرسنلی</Accordion.Header>
                                                <Accordion.Body>
                                                    {this.renderPersonDocRow('personnelImg', 'عکس پرسنلی')}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="3">
                                                <Accordion.Header>پرینت ثبت نام </Accordion.Header>
                                                <Accordion.Body>
                                                    {this.renderPersonDocRow('register', 'پرینت ثبت نام')}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="4">
                                                <Accordion.Header>پرینت ثبت نام دانشگاه</Accordion.Header>
                                                <Accordion.Body>
                                                    {this.renderPersonDocRow('registerUni', 'ثبت نام دانشگاه')}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </Tab>
                                <Tab eventKey="commitments" title="تعهدات" className='records'
                                     style={{backgroundColor: "transparent"}}>
                                    <div className="tabs-content">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>اسکن تعهدنامه</Accordion.Header>
                                                <Accordion.Body>
                                                    {
                                                        this.commitmentHistory().length ? (
                                                            this.commitmentHistory().map((item, idx) => {
                                                                const isCurrent = item.fileId === this.state.docFile?.commitmentLetter;
                                                                const busy = this.state.commitmentUploadLoading
                                                                    || this.state.docUploadLoadingKey === `commitment:${item.fileId}`;
                                                                return (
                                                                    <div
                                                                        key={item.fileId || item.id || idx}
                                                                        className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2 p-2 border rounded"
                                                                    >
                                                                        <div className="ms-1">
                                                                            تعهدنامه {this.commitmentHistory().length > 1 ? `${idx + 1}` : ''}
                                                                            {item.originalName ? (
                                                                                <span className="text-muted small ms-2">({item.originalName})</span>
                                                                            ) : null}
                                                                            {isCurrent ? (
                                                                                <span className="badge bg-success ms-2">فعلی</span>
                                                                            ) : null}
                                                                        </div>
                                                                        <div className="d-flex flex-wrap gap-1">
                                                                            <button type="button" className="btn btn-sm btn-outline-secondary"
                                                                                    disabled={busy}
                                                                                    onClick={() => this.downloadFile(item.fileId)}>
                                                                                دانلود
                                                                            </button>
                                                                            {!isCurrent ? (
                                                                                <button type="button" className="btn btn-sm btn-outline-primary"
                                                                                        disabled={busy}
                                                                                        onClick={() => this.setCurrentCommitment(item.fileId)}>
                                                                                    تنظیم به‌عنوان فعلی
                                                                                </button>
                                                                            ) : null}
                                                                            <label className="btn btn-sm btn-outline-primary mb-0">
                                                                                ویرایش
                                                                                <input
                                                                                    type="file"
                                                                                    hidden
                                                                                    accept="image/jpeg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.pdf,application/pdf"
                                                                                    disabled={busy}
                                                                                    onChange={(e) => this.uploadCommitmentLetter(e)}
                                                                                />
                                                                            </label>
                                                                            <button type="button" className="btn btn-sm btn-outline-danger"
                                                                                    disabled={busy}
                                                                                    onClick={() => this.deleteCommitmentEntry(item)}>
                                                                                حذف
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div className="text-muted mb-2">تعهدنامه‌ای ثبت نشده است.</div>
                                                        )
                                                    }
                                                    <div className="mt-3">
                                                        <label className="form-label">آپلود / تعویض تعهدنامه</label>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="file"
                                                            accept="image/jpeg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.pdf,application/pdf"
                                                            disabled={this.state.commitmentUploadLoading}
                                                            onChange={this.uploadCommitmentLetter}
                                                        />
                                                        <div className="text-muted small mt-1">
                                                            فرمت‌های مجاز: JPG، PNG، PDF — حداکثر ۵۰ مگابایت
                                                        </div>
                                                        {this.state.commitmentUploadLoading ? (
                                                            <div className="text-muted small mt-1">در حال آپلود...</div>
                                                        ) : null}
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </div>
                <Modal className='report-modal' centered show={this.state.show}>
                    <Modal.Header>
                        <Modal.Title><span>ثبت گزارش</span></Modal.Title>
                        <button className='btn' onClick={() => {
                            this.handleClose()
                        }}><AiOutlineClose/></button>
                    </Modal.Header>
                    <Modal.Body>
                        <form className="my-3 mx-2" onSubmit={this.handleSubmit}>
                            <div className='input-report-box'>
                                <FormControl className={"w-100"} style={{border: "none"}}>
                                    <Select
                                        sx={{ height: 50, borderRadius: "0.5rem", minWidth: '10rem', backgroundColor: "#fff"}}
                                        id="select-field"
                                        value={this.state.reportType}
                                        onChange={(e) => {
                                            this.reportType(e);
                                            this.handleResetFields();}}>
                                        <MenuItem value={"cleaning"}>نوبت نظافت شبانه</MenuItem>
                                        <MenuItem value={"delayInArrival"}>تأخیر در ورود</MenuItem>
                                        <MenuItem value={"exit"}>خروج</MenuItem>
                                        <MenuItem value={"exitSecondary"}>خروج دوم / گزارش کار</MenuItem>
                                        <MenuItem value={"workReport"}>گزارش کار روزانه</MenuItem>
                                        <MenuItem value={"violation"}>ثبت تخلف</MenuItem>
                                        <MenuItem value={"penalty"}>ثبت جریمه</MenuItem>
                                        <MenuItem value={"discharge"}>اعلام تخلیه</MenuItem>
                                        <MenuItem value={"cancelContract"}>لغو قرارداد</MenuItem>
                                    </Select>
                                    <label className="placeholder" style={{
                                        top: '-10px',
                                        backgroundColor: '#fff',
                                        color: '#2a2e32b3',
                                        margin: '-0.2rem 0',
                                        padding: '0 .4rem -0.4rem',
                                        opacity: '1',
                                    }}>نوع گزارش</label>
                                </FormControl>

                                {/*<select className='input' onChange={(e) => {*/}
                                {/*    this.reportType(e);*/}
                                {/*    this.handleResetFields();*/}
                                {/*}}>*/}
                                {/*    <option value='cleaning'>نوبت نظافت شبانه</option>*/}
                                {/*    <option value='delayInArrival'>تأخیر در ورود</option>*/}
                                {/*    <option value='exit'>خروج</option>*/}
                                {/*    <option value='violation'>ثبت تخلف</option>*/}
                                {/*    <option value='penalty'>ثبت جریمه</option>*/}
                                {/*    <option value='discharge'>اعلام تخلیه</option>*/}
                                {/*    <option value='cancelContract'>لغو قرارداد</option>*/}
                                {/*</select>*/}
                                {/*<label className="placeholder">نوع گزارش</label>*/}
                            </div>
                            {(() => {
                                switch (this.state.reportType) {
                                    case 'cleaning':
                                        return <>
                                            <div className='input-report-box'>
                                                <DatePicker
                                                    // fixMainPosition={false}
                                                    inputClass={"input form-control date-picker"}
                                                    ref={this.date}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}


                                                    containerStyle={{
                                                        width: "100%"
                                                    }}

                                                    value={this.state.dateValues.cleaningDate}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.cleaningDate = value;
                                                        this.setState(updatedDateValues)
                                                    }}
                                                    mapDays={({date}) => {
                                                        let props = {}
                                                        let isWeekend = [6].includes(date.weekDay.index)

                                                        if (isWeekend)
                                                            props.className = "highlight highlight-red";

                                                        return props
                                                    }}

                                                    weekDays={
                                                        [
                                                            ["شنبه", "Sat"],
                                                            ["یکشنبه", "Sun"],
                                                            ["دوشنبه", "Mon"],
                                                            ["سه شنبه", "Tue"],
                                                            ["چهارشنبه", "Wed"],
                                                            ["پنجشنبه", "Thu"],
                                                            ["جمعه", "Fri"],
                                                        ]
                                                    }

                                                    calendar={persian}
                                                    locale={persian_fa}

                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.cleaningDate = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                {/*<input type="text" ref={this.date} className="input" placeholder=" "/>*/}
                                                <label className="placeholder">تاریخ</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.penaltyAmount} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">مبلغ نظافت</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.description} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">توضیحات</label>
                                            </div>
                                        </>;
                                    case 'delayInArrival':
                                        return <>
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.date} className="input" placeholder=" "/>*/}
                                                <DatePicker
                                                    // fixMainPosition={false}
                                                    ref={this.date}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}
                                                    inputClass={`input form-control date-picker`}


                                                    containerStyle={{
                                                        width: "100%"
                                                    }}

                                                    value={this.state.dateValues.delayInArrivalDate}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.delayInArrivalDate = value;
                                                        this.setState(updatedDateValues)
                                                    }}

                                                    mapDays={({date}) => {
                                                        let props = {}
                                                        let isWeekend = [6].includes(date.weekDay.index)

                                                        if (isWeekend)
                                                            props.className = "highlight highlight-red";

                                                        return props
                                                    }}

                                                    weekDays={
                                                        [
                                                            ["شنبه", "Sat"],
                                                            ["یکشنبه", "Sun"],
                                                            ["دوشنبه", "Mon"],
                                                            ["سه شنبه", "Tue"],
                                                            ["چهارشنبه", "Wed"],
                                                            ["پنجشنبه", "Thu"],
                                                            ["جمعه", "Fri"],
                                                        ]
                                                    }

                                                    calendar={persian}
                                                    locale={persian_fa}

                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.delayInArrivalDate = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">تاریخ</label>
                                            </div>
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.time} className="input" placeholder=" "/>*/}
                                                <DatePicker
                                                    ref={this.time}
                                                    disableDayPicker
                                                    format="HH:mm:ss"
                                                    inputClass={`input form-control date-picker`}
                                                    containerStyle={{
                                                        width: "100%"
                                                    }}
                                                    value={this.state.dateValues.delayInArriveTime}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.delayInArriveTime = value;
                                                        this.setState(updatedDateValues)
                                                    }}
                                                    plugins={[
                                                        <TimePicker/>
                                                    ]}
                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.delayInArriveTime = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">ساعت</label>
                                            </div>
                                        </>;
                                    case 'exitSecondary':
                                    case 'exit':
                                        return <>
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.startDate} className="input"*/}
                                                {/*       placeholder=" "/>*/}
                                                <DatePicker
                                                    // fixMainPosition={false}
                                                    ref={this.startDate}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}
                                                    inputClass={`input form-control date-picker`}


                                                    containerStyle={{
                                                        width: "100%"
                                                    }}

                                                    value={this.state.dateValues.exitStartDate}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.exitStartDate = value;
                                                        this.setState(updatedDateValues)
                                                    }}

                                                    mapDays={({date}) => {
                                                        let props = {}
                                                        let isWeekend = [6].includes(date.weekDay.index)

                                                        if (isWeekend)
                                                            props.className = "highlight highlight-red";

                                                        return props
                                                    }}

                                                    weekDays={
                                                        [
                                                            ["شنبه", "Sat"],
                                                            ["یکشنبه", "Sun"],
                                                            ["دوشنبه", "Mon"],
                                                            ["سه شنبه", "Tue"],
                                                            ["چهارشنبه", "Wed"],
                                                            ["پنجشنبه", "Thu"],
                                                            ["جمعه", "Fri"],
                                                        ]
                                                    }

                                                    calendar={persian}
                                                    locale={persian_fa}

                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.exitStartDate = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">از تاريخ</label>
                                            </div>
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.endDate} className="input"*/}
                                                {/*       placeholder=" "/>*/}
                                                <DatePicker
                                                    // fixMainPosition={false}
                                                    ref={this.endDate}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}
                                                    inputClass={`input form-control date-picker`}


                                                    containerStyle={{
                                                        width: "100%"
                                                    }}

                                                    value={this.state.dateValues.exitEndDate}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.exitEndDate = value;
                                                        this.setState(updatedDateValues)
                                                    }}

                                                    mapDays={({date}) => {
                                                        let props = {}
                                                        let isWeekend = [6].includes(date.weekDay.index)

                                                        if (isWeekend)
                                                            props.className = "highlight highlight-red";

                                                        return props
                                                    }}

                                                    weekDays={
                                                        [
                                                            ["شنبه", "Sat"],
                                                            ["یکشنبه", "Sun"],
                                                            ["دوشنبه", "Mon"],
                                                            ["سه شنبه", "Tue"],
                                                            ["چهارشنبه", "Wed"],
                                                            ["پنجشنبه", "Thu"],
                                                            ["جمعه", "Fri"],
                                                        ]
                                                    }

                                                    calendar={persian}
                                                    locale={persian_fa}

                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.exitEndDate = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">تا تاريخ</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.destinationAddress} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">آدرس مقصد</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.destinationPhoneNumber} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">شماره تماس مقصد</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.relation} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">نسبت</label>
                                            </div>
                                        </>;
                                    case 'workReport':
                                        return <>
                                            <div className='input-report-box'>
                                                <DatePicker
                                                    ref={this.date}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}
                                                    inputClass={`input form-control date-picker`}
                                                    containerStyle={{width: "100%"}}
                                                    portal
                                                    zIndex={10000}
                                                    value={this.state.dateValues.workReportDate}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.workReportDate = value;
                                                        this.setState(updatedDateValues)
                                                    }}
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                >
                                                    <Button onClick={() => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.workReportDate = {};
                                                        this.setState(updatedDateValues)
                                                    }}>ریست</Button>
                                                </DatePicker>
                                                <label className="placeholder">تاریخ</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.description} className="input"
                                                       placeholder=" "
                                                       defaultValue={this.state.editingWorkReport?.description || ''}/>
                                                <label className="placeholder">شرح گزارش کار</label>
                                            </div>
                                        </>;
                                    case 'violation':
                                        return <>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.description} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">گزارش تخلف</label>
                                            </div>
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.date} className="input" placeholder=" "/>*/}
                                                <DatePicker
                                                    // fixMainPosition={false}
                                                    ref={this.date}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}
                                                    inputClass={`input form-control date-picker`}


                                                    containerStyle={{
                                                        width: "100%"
                                                    }}

                                                    value={this.state.dateValues.violationDate}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.violationDate = value;
                                                        this.setState(updatedDateValues)
                                                    }}

                                                    mapDays={({date}) => {
                                                        let props = {}
                                                        let isWeekend = [6].includes(date.weekDay.index)

                                                        if (isWeekend)
                                                            props.className = "highlight highlight-red";

                                                        return props
                                                    }}

                                                    weekDays={
                                                        [
                                                            ["شنبه", "Sat"],
                                                            ["یکشنبه", "Sun"],
                                                            ["دوشنبه", "Mon"],
                                                            ["سه شنبه", "Tue"],
                                                            ["چهارشنبه", "Wed"],
                                                            ["پنجشنبه", "Thu"],
                                                            ["جمعه", "Fri"],
                                                        ]
                                                    }

                                                    calendar={persian}
                                                    locale={persian_fa}

                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.violationDate = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">تاریخ</label>
                                            </div>
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.time} className="input" placeholder=" "/>*/}
                                                <DatePicker
                                                    ref={this.time}
                                                    disableDayPicker
                                                    format="HH:mm:ss"
                                                    inputClass={`input form-control date-picker`}
                                                    containerStyle={{
                                                        width: "100%"
                                                    }}
                                                    value={this.state.dateValues.violationTime}
                                                    onChange={(value) => {
                                                        console.log(value)
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.violationTime = value;
                                                        this.setState(updatedDateValues)
                                                    }}
                                                    plugins={[
                                                        <TimePicker/>
                                                    ]}
                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.violationTime = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">ساعت</label>
                                            </div>
                                        </>;
                                    case 'penalty':
                                        return (<>
                                            <div className='input-report-box'>
                                                <select ref={this.typePenalty} className='input'>
                                                    <option value='financial'>نقدی</option>
                                                    <option value='nonFinancial'>تنبیهی</option>
                                                </select>
                                                <label className="placeholder">نوع جریمه</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.penaltyAmount} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">مقدار جریمه</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.description} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">دلیل جریمه</label>
                                            </div>

                                        </>);
                                    case 'discharge':
                                        return <>
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.dischargeDateAnnounce} className="input"*/}
                                                {/*       placeholder=" "/>*/}
                                                <DatePicker
                                                    // fixMainPosition={false}
                                                    ref={this.dischargeDateAnnounce}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}
                                                    inputClass={`input form-control date-picker`}


                                                    containerStyle={{
                                                        width: "100%"
                                                    }}

                                                    value={this.state.dateValues.dischargeDateAnnounce}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.dischargeDateAnnounce = value;
                                                        this.setState(updatedDateValues)
                                                    }}

                                                    mapDays={({date}) => {
                                                        let props = {}
                                                        let isWeekend = [6].includes(date.weekDay.index)

                                                        if (isWeekend)
                                                            props.className = "highlight highlight-red";

                                                        return props
                                                    }}

                                                    weekDays={
                                                        [
                                                            ["شنبه", "Sat"],
                                                            ["یکشنبه", "Sun"],
                                                            ["دوشنبه", "Mon"],
                                                            ["سه شنبه", "Tue"],
                                                            ["چهارشنبه", "Wed"],
                                                            ["پنجشنبه", "Thu"],
                                                            ["جمعه", "Fri"],
                                                        ]
                                                    }

                                                    calendar={persian}
                                                    locale={persian_fa}

                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.dischargeDateAnnounce = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">تاریخ اعلام تخلیه</label>
                                            </div>
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.dischargeDate} className="input"*/}
                                                {/*       placeholder=" "/>*/}
                                                <DatePicker
                                                    // fixMainPosition={false}
                                                    ref={this.dischargeDate}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}
                                                    inputClass={`input form-control date-picker`}


                                                    containerStyle={{
                                                        width: "100%"
                                                    }}

                                                    value={this.state.dateValues.dischargeDate}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.dischargeDate = value;
                                                        this.setState(updatedDateValues)
                                                    }}

                                                    mapDays={({date}) => {
                                                        let props = {}
                                                        let isWeekend = [6].includes(date.weekDay.index)

                                                        if (isWeekend)
                                                            props.className = "highlight highlight-red";

                                                        return props
                                                    }}

                                                    weekDays={
                                                        [
                                                            ["شنبه", "Sat"],
                                                            ["یکشنبه", "Sun"],
                                                            ["دوشنبه", "Mon"],
                                                            ["سه شنبه", "Tue"],
                                                            ["چهارشنبه", "Wed"],
                                                            ["پنجشنبه", "Thu"],
                                                            ["جمعه", "Fri"],
                                                        ]
                                                    }

                                                    calendar={persian}
                                                    locale={persian_fa}

                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.dischargeDate = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">تاریخ تخلیه</label>
                                            </div>
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.depositReturnDate} className="input"*/}
                                                {/*       placeholder=" "/>*/}
                                                <DatePicker
                                                    // fixMainPosition={false}
                                                    ref={this.depositReturnDate}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}
                                                    inputClass={`input form-control date-picker`}


                                                    containerStyle={{
                                                        width: "100%"
                                                    }}

                                                    value={this.state.dateValues.depositReturnDate}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.depositReturnDate = value;
                                                        this.setState(updatedDateValues)
                                                    }}

                                                    mapDays={({date}) => {
                                                        let props = {}
                                                        let isWeekend = [6].includes(date.weekDay.index)

                                                        if (isWeekend)
                                                            props.className = "highlight highlight-red";

                                                        return props
                                                    }}

                                                    weekDays={
                                                        [
                                                            ["شنبه", "Sat"],
                                                            ["یکشنبه", "Sun"],
                                                            ["دوشنبه", "Mon"],
                                                            ["سه شنبه", "Tue"],
                                                            ["چهارشنبه", "Wed"],
                                                            ["پنجشنبه", "Thu"],
                                                            ["جمعه", "Fri"],
                                                        ]
                                                    }

                                                    calendar={persian}
                                                    locale={persian_fa}

                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.depositReturnDate = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">تاریخ عودت ودیعه</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.deductionOfLosses} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">کسر ضرر و زیان</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.deductionOfLossesReason} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">علت کسر ضر و زیان</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.refundableAmount} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">مبلغ قابل عودت</label>
                                            </div>
                                        </>;
                                    case 'cancelContract':
                                        return <>
                                            {/*<div className='input-report-box'>
                                                <input type="text" className="input" placeholder=" "/>
                                                <label className="placeholder">روز</label>
                                            </div>*/}
                                            <div className='input-report-box'>
                                                {/*<input type="text" ref={this.date} className="input" placeholder=" "/>*/}
                                                <DatePicker
                                                    // fixMainPosition={false}
                                                    ref={this.date}
                                                    calendarPosition={`top`}
                                                    digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                                    format={`YYYY/MM/DD`}
                                                    inputClass={`input form-control date-picker`}


                                                    containerStyle={{
                                                        width: "100%"
                                                    }}

                                                    value={this.state.dateValues.cancelContractDate}
                                                    onChange={(value) => {
                                                        let updatedDateValues = {...this.state};
                                                        updatedDateValues.dateValues.cancelContractDate = value;
                                                        this.setState(updatedDateValues)
                                                    }}

                                                    mapDays={({date}) => {
                                                        let props = {}
                                                        let isWeekend = [6].includes(date.weekDay.index)

                                                        if (isWeekend)
                                                            props.className = "highlight highlight-red";

                                                        return props
                                                    }}

                                                    weekDays={
                                                        [
                                                            ["شنبه", "Sat"],
                                                            ["یکشنبه", "Sun"],
                                                            ["دوشنبه", "Mon"],
                                                            ["سه شنبه", "Tue"],
                                                            ["چهارشنبه", "Wed"],
                                                            ["پنجشنبه", "Thu"],
                                                            ["جمعه", "Fri"],
                                                        ]
                                                    }

                                                    calendar={persian}
                                                    locale={persian_fa}

                                                >
                                                    <Button
                                                        onClick={() => {
                                                            let updatedDateValues = {...this.state};
                                                            updatedDateValues.dateValues.cancelContractDate = {};
                                                            this.setState(updatedDateValues)
                                                        }
                                                        }
                                                    >
                                                        ریست
                                                    </Button>
                                                </DatePicker>
                                                <label className="placeholder">تاریخ</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.reason} className="input" placeholder=" "/>
                                                <label className="placeholder">علت</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.deductionOfLosses} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">کسر ضرر و زیان</label>
                                            </div>
                                            <div className='input-report-box'>
                                                <input type="text" ref={this.refundableAmount} className="input"
                                                       placeholder=" "/>
                                                <label className="placeholder">مبلغ قابل عودت</label>
                                            </div>
                                        </>
                                }
                            })()}
                            <div className="input-report-box">
                                <button className='btn-done w-100' disabled={this.state.registerLoading}>ثبت</button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.showDeleteModalReport}>
                    <Modal.Header>
                        <Modal.Title>حذف گزارش</Modal.Title>
                        <button className='btn' onClick={() => {
                            this.handleCloseModalReport()
                        }}><AiOutlineClose/></button>
                    </Modal.Header>
                    <Modal.Body>
                        <h6>آيا از حذف اين گزارش مطمئن هستيد؟</h6>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-start">
                        <button className="btn btn-danger" onClick={() => this.handleDeleteReport()}>حذف</button>
                        <button className="btn btn-light" onClick={() => this.handleCloseModalReport()}>بستن</button>
                    </Modal.Footer>
                </Modal>
                <Modal centered show={this.state.showEditReturnModal} onHide={() => this.setState({showEditReturnModal: false})}>
                    <Modal.Header>
                        <Modal.Title>ویرایش عودت</Modal.Title>
                        <button className='btn' onClick={() => this.setState({showEditReturnModal: false})}><AiOutlineClose/></button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-3">
                            <label className="form-label">مبلغ قابل عودت</label>
                            <input className="form-control" value={this.state.editReturnAmount}
                                   onChange={(e) => this.setState({editReturnAmount: e.target.value})}/>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">تاریخ عودت (YYYY/MM/DD)</label>
                            <input className="form-control" value={this.state.editReturnDate}
                                   onChange={(e) => this.setState({editReturnDate: e.target.value})}/>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-start">
                        <button className="btn btn-success" onClick={this.saveEditReturn}>ذخیره</button>
                        <button className="btn btn-light" onClick={() => this.setState({showEditReturnModal: false})}>بستن</button>
                    </Modal.Footer>
                </Modal>
                <Modal centered show={this.state.showExtendBedModal} onHide={this.closeExtendBedModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>تمدید تاریخ اتمام پذیرش</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="form-label">تاریخ جدید اتمام (شمسی)</label>
                        <DatePicker
                            value={this.state.extendBedDateDraft}
                            onChange={(date) => {
                                const formatted = date?.format?.('YYYY/MM/DD') || '';
                                this.setState({extendBedDateDraft: formatted});
                            }}
                            calendar={persian}
                            locale={persian_fa}
                            format="YYYY/MM/DD"
                            inputClass="form-control"
                        />
                    </Modal.Body>
                    <Modal.Footer className="justify-content-start">
                        <button type="button" className="btn btn-success btn-sm"
                                disabled={this.state.extendBedSaving}
                                onClick={this.extendBedEndDate}>تأیید تمدید</button>
                        <button type="button" className="btn btn-light btn-sm"
                                onClick={this.closeExtendBedModal}>انصراف</button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    handleResetFields = () => {
        let resetFields = {
            cleaningDate: '',
            workReportDate: '',
            delayInArrivalDate: '',
            delayInArriveTime: '',
            exitStartDate: '',
            exitEndDate: '',
            violationDate: '',
            violationTime: '',
            dischargeDateAnnounce: '',
            dischargeDate: '',
            depositReturnDate: '',
            cancelContractDate: '',
        };
        this.setState({dateValues: resetFields, editingWorkReport: null});
    }
    handleClose = () => {
        this.setState({show: false, editingWorkReport: null})
    };
    handleShow = () => {
        this.setState({show: true})
    };
    reportType = (e) => {
        const type = e.target.value
        this.setState({reportType: type})
    }
    handleSubmit = (e) => {
        e.preventDefault();
        // console.log(this.state.dateValues.cleaningDate)
        const type = this.state.reportType;

        this.setState({reports: type});
        switch (type) {
            case 'cleaning':
                return (async () => {
                    this.setState({registerLoading: true});
                    const date = this.state.dateValues.cleaningDate;
                    const formattedDate = formatDateObject(date)
                    const description = this.description.current.value;
                    const cleaningAmount = this.penaltyAmount.current ? this.penaltyAmount.current.value : '';
                    const result = {
                        'title': "cleaning",
                        'date': formattedDate,
                        'checkCleaning': true,
                        'description': description,
                        'penaltyAmount': cleaningAmount,
                        'personId': this.state.personObject.id
                    }

                    await axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                        .then((data) => {
                            this.setState({registerLoading: false});
                            const newReports = (this.state.report || []).concat(data);
                            this.setState({report: newReports});
                            this.setState({show: false});
                        })
                        // .catch((error) => {
                        //     this.setState({registerLoading: false})
                        // })
                        .catch(() => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then((response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                            .then((data) => {
                                                this.setState({registerLoading: false});
                                                const newReports = (this.state.report || []).concat(data);
                                                this.setState({report: newReports});
                                                this.setState({show: false});
                                            })
                                            // .catch((error) => {
                                            //     this.setState({registerLoading: false})
                                            // })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then((response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                            .then((data) => {
                                                this.setState({registerLoading: false});
                                                const newReports = (this.state.report || []).concat(data);
                                                this.setState({report: newReports});
                                                this.setState({show: false});
                                            })
                                            // .catch((error) => {
                                            //     this.setState({registerLoading: false})
                                            // })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }})
                })();
            case 'delayInArrival':
                return (async () => {
                    this.setState({registerLoading: true});
                    const date = this.state.dateValues.delayInArrivalDate;
                    const formattedDate = formatDateObject(date)
                    const time = this.state.dateValues.delayInArriveTime;
                    const formattedTime = time.hour + ':' + time.minute;

                    const result = {
                        'title': 'delayInArrival',
                        'date': formattedDate,
                        'hour': formattedTime,
                        'personId': this.state.personObject.id
                    }

                    await axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                        .then((data) => {
                            this.setState({registerLoading: false});
                            const newReports = (this.state.report || []).concat(data);
                            this.setState({report: newReports});
                            this.setState({show: false});
                        })
                        // .catch((error) => {
                        //     this.setState({registerLoading: false})
                        // })
                        .catch(() => {
                            if (localStorage.getItem('role') === 'MANAGER') {
                                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            }})
                })();

            case 'exitSecondary':
            case 'exit':
                return (async () => {
                    this.setState({registerLoading: true});
                    const startDate = this.state.dateValues.exitStartDate;
                    const endDate = this.state.dateValues.exitEndDate;
                    const formattedStartDate = formatDateObject(startDate);
                    const formattedEndDate = formatDateObject(endDate);
                    const destinationAddress = this.destinationAddress.current.value;
                    const destinationPhoneNumber = this.destinationPhoneNumber.current.value;
                    const relation = this.relation.current.value;
                    const result = {
                        'title': type,
                        "startDate": formattedStartDate,
                        "endDate": formattedEndDate,
                        'destinationAddress': destinationAddress,
                        'destinationPhoneNumber': destinationPhoneNumber,
                        'relation': relation,
                        'personId': this.state.personObject.id
                    }

                    await axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                        .then((data) => {
                            this.setState({registerLoading: false});
                            const newReports = (this.state.report || []).concat(data);
                            this.setState({report: newReports});
                            this.setState({show: false});
                        })
                        // .catch((error) => {
                        //     this.setState({registerLoading: false})
                        // })
                        .catch(() => {
                            if (localStorage.getItem('role') === 'MANAGER') {
                                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            }})

                })();

            case 'workReport':
                return (async () => {
                    this.setState({registerLoading: true});
                    const date = this.state.dateValues.workReportDate;
                    const formattedDate = formatDateObject(date);
                    const description = this.description.current?.value || '';
                    const result = {
                        'title': 'workReport',
                        'date': formattedDate,
                        'description': description,
                        'personId': this.state.personObject.id
                    };
                    const editingId = this.state.editingWorkReport?.id;
                    const request = editingId
                        ? axios.put(`${API_BASE_URL}/api/v1/supervisor/record/${editingId}`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                        : axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}});
                    await request.then(response => response.data)
                        .then((data) => {
                            this.setState({registerLoading: false, editingWorkReport: null});
                            if (editingId) {
                                const newReports = (this.state.report || []).map((r) => r.id === editingId ? data : r);
                                this.setState({report: newReports, show: false});
                            } else {
                                const newReports = (this.state.report || []).concat(data);
                                this.setState({report: newReports, show: false});
                            }
                        })
                        .catch(() => {
                            this.setState({registerLoading: false});
                            window.alert('ثبت گزارش کار ناموفق بود');
                        });
                })();

            case 'violation':
                return (async () => {

                    this.setState({registerLoading: true});

                    const date = this.state.dateValues.violationDate;
                    const formattedDate = formatDateObject(date)
                    const time = this.state.dateValues.violationTime;
                    const formattedTime = time.hour + ':' + time.minute
                    const description = this.description.current.value;
                    const result = {
                        'title': 'violation',
                        'date': formattedDate,
                        'hour': formattedTime,
                        'description': description,
                        'personId': this.state.personObject.id
                    }

                    await axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                        .then((data) => {
                            this.setState({registerLoading: false});
                            const newReports = (this.state.report || []).concat(data);
                            this.setState({report: newReports});
                            this.setState({show: false});
                        })
                        // .catch((error) => {
                        //     this.setState({registerLoading: false})
                        // })
                        .catch(() => {
                            if (localStorage.getItem('role') === 'MANAGER') {
                                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            }})

                })();
            case 'penalty':
                return (async () => {
                    this.setState({registerLoading: true});
                    const description = this.description.current.value;
                    const typePenalty = this.typePenalty.current.value;
                    const penaltyAmount = this.penaltyAmount.current.value;
                    const result = {
                        'title': 'penalty',
                        'penaltyType': typePenalty,
                        'description': description,
                        'penaltyAmount': penaltyAmount,
                        'personId': this.state.personObject.id
                    }

                    await axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                        .then((data) => {
                            this.setState({registerLoading: false});
                            const newReports = (this.state.report || []).concat(data);
                            this.setState({report: newReports});
                            this.setState({show: false});
                        })
                        // .catch((error) => {
                        //     this.setState({registerLoading: false})
                        // })
                        .catch(() => {
                            if (localStorage.getItem('role') === 'MANAGER') {
                                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            }})

                })();
            case 'discharge':
                return (async () => {
                    this.setState({registerLoading: true});
                    const dischargeDateAnnounce = this.state.dateValues.dischargeDateAnnounce;
                    const dischargeDate = this.state.dateValues.dischargeDate;
                    const depositReturnDate = this.state.dateValues.depositReturnDate;

                    let formattedDischargeDateAnnounce = formatDateObject(dischargeDateAnnounce);
                    let formattedDischargeDate = formatDateObject(dischargeDate);
                    let formattedDepositReturnDate = formatDateObject(depositReturnDate);

                    const deductionOfLosses = this.deductionOfLosses.current.value;
                    const deductionOfLossesReason = this.deductionOfLossesReason.current.value;
                    const refundableAmount = this.refundableAmount.current.value;
                    const result = {
                        'title': 'discharge',
                        'startDate': formattedDischargeDateAnnounce,
                        'endDate': formattedDischargeDate,
                        'date': formattedDepositReturnDate,
                        'penaltyAmount': deductionOfLosses,
                        'description': deductionOfLossesReason,
                        'returnedAmount': refundableAmount,
                        'personId': this.state.personObject.id
                    }

                   await axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                        .then((data) => {
                            this.setState({registerLoading: false});
                            const newReports = (this.state.report || []).concat(data);
                            this.setState({report: newReports});
                            this.setState({show: false});
                        })
                        // .catch((error) => {
                        //     this.setState({registerLoading: false})
                        // })
                        .catch(() => {
                            if (localStorage.getItem('role') === 'MANAGER') {
                                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            }})
                })();

            case 'cancelContract':
                return (async () => {
                    this.setState({registerLoading: true});
                    const date = this.state.dateValues.cancelContractDate;
                    const formattedDate = formatDateObject(date);
                    const reason = this.reason.current.value;
                    const deductionOfLosses = this.deductionOfLosses.current.value;
                    const refundableAmount = this.refundableAmount.current.value;
                    const result = {
                        'title': 'cancelContract',
                        'date': formattedDate,
                        'description': reason,
                        'penaltyAmount': deductionOfLosses,
                        'returnedAmount': refundableAmount,
                        'personId': this.state.personObject.id
                    }

                    await axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                        .then((data) => {
                            this.setState({registerLoading: false});
                            const newReports = (this.state.report || []).concat(data);
                            this.setState({report: newReports});
                            this.setState({show: false});
                        })
                        // .catch((error) => {
                        //     this.setState({registerLoading: false})
                        // })
                        .catch(() => {
                            if (localStorage.getItem('role') === 'MANAGER') {
                                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                    .then((response) => {
                                        if (response.headers["accesstoken"]) {
                                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                            axios.post(`${API_BASE_URL}/api/v1/supervisor/record`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                                .then((data) => {
                                                    this.setState({registerLoading: false});
                                                    const newReports = (this.state.report || []).concat(data);
                                                    this.setState({report: newReports});
                                                    this.setState({show: false});
                                                })
                                                // .catch((error) => {
                                                //     this.setState({registerLoading: false})
                                                // })
                                        } else {
                                            window.location = '/'
                                        }
                                    })
                            }})
                })();
        }
    }
    handleOpenModalReport = (c) => {
        this.setState({showDeleteModalReport: true});
        this.setState({reportTemp: c});
        console.log(c)
    }
    handleCloseModalReport = () => {
        this.setState({showDeleteModalReport: false});
    }

    handleDeleteReport = async () => {
        console.log(this.state.reportTemp)
        await axios.delete(`${API_BASE_URL}/api/v1/supervisor/record/${this.state.reportTemp.id}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => {
                let index = this.state.report.indexOf(this.state.reportTemp)
                let updatedReport = [...this.state.report];
                updatedReport.splice(index, 1);
                this.setState({report: updatedReport});
                this.setState({showDeleteModalReport: false})
            })
            // .catch((error) => {
            //     console.log(error);
            //     this.setState({showDeleteModalReport: false})
            // })
            .catch(() => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                axios.delete(`${API_BASE_URL}/api/v1/supervisor/record/${this.state.reportTemp.id}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then((data) => {
                                        let index = this.state.report.indexOf(this.state.reportTemp)
                                        let updatedReport = [...this.state.report];
                                        updatedReport.splice(index, 1);
                                        this.setState({report: updatedReport});
                                        this.setState({showDeleteModalReport: false})
                                    })
                                    // .catch((error) => {
                                    //     console.log(error);
                                    //     this.setState({showDeleteModalReport: false})
                                    // })
                            } else {
                                window.location = '/'
                            }
                        })
                } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                    axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"])
                                axios.delete(`${API_BASE_URL}/api/v1/supervisor/record/${this.state.reportTemp.id}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then((data) => {
                                        let index = this.state.report.indexOf(this.state.reportTemp)
                                        let updatedReport = [...this.state.report];
                                        updatedReport.splice(index, 1);
                                        this.setState({report: updatedReport});
                                        this.setState({showDeleteModalReport: false})
                                    })
                                    // .catch((error) => {
                                    //     console.log(error);
                                    //     this.setState({showDeleteModalReport: false})
                                    // })
                            } else {
                                window.location = '/'
                            }
                        })
                }})
    }

    downloadFile = async (fId) => {
        if (!fId) {
            window.alert('شناسه فایل یافت نشد');
            return;
        }
        const file = (this.state.fileDetails || []).find(({fileId}) => fId === fileId);
        const filename = file?.originalName || file?.name || 'download';
        const saveBlob = (blob) => {
            if (blob == null) {
                window.alert('دانلود فایل ناموفق بود');
                return;
            }
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        };
        try {
            const blob = await axios.get(`${API_BASE_URL}/api/v1/supervisor/file/${fId}`, {
                responseType: "blob",
                headers: {'Authorization': localStorage.getItem('accessToken')}
            }).then(response => response.data);
            saveBlob(blob);
        } catch (err) {
            if (err?.response?.status !== 401 && err?.response?.status !== 403) {
                window.alert('دانلود فایل ناموفق بود');
                return;
            }
            const role = localStorage.getItem('role');
            const refreshUrl = role === 'MANAGER'
                ? `${API_BASE_URL}/api/v1/manager/token/refresh`
                : role === 'SUPERVISOR'
                    ? `${API_BASE_URL}/api/v1/supervisor/token/refresh`
                    : null;
            if (!refreshUrl) {
                window.location = '/';
                return;
            }
            try {
                const refreshed = await axios.get(refreshUrl, {
                    headers: {'Authorization': localStorage.getItem('refreshToken')}
                });
                if (!refreshed.headers["accesstoken"]) {
                    window.location = '/';
                    return;
                }
                localStorage.setItem("accessToken", refreshed.headers["accesstoken"]);
                const blob = await axios.get(`${API_BASE_URL}/api/v1/supervisor/file/${fId}`, {
                    responseType: "blob",
                    headers: {'Authorization': localStorage.getItem('accessToken')}
                }).then(response => response.data);
                saveBlob(blob);
            } catch (e2) {
                window.alert('دانلود فایل ناموفق بود');
            }
        }
    }

    commitmentHistory = () => {
        const details = Array.isArray(this.state.fileDetails) ? this.state.fileDetails : [];
        const byName = details.filter((f) => f.name === 'commitmentLetter');
        if (byName.length) {
            return byName;
        }
        const currentId = this.state.docFile?.commitmentLetter;
        if (currentId) {
            return [{fileId: currentId, originalName: 'تعهدنامه', name: 'commitmentLetter'}];
        }
        return [];
    }

    refreshFileDetails = async (parentId) => {
        if (!parentId) return;
        try {
            const data = await axios.get(
                `${API_BASE_URL}/api/v1/supervisor/responseFile/search?parentType=Person&parentId=${parentId}`,
                {headers: {'Authorization': localStorage.getItem('accessToken')}}
            ).then(r => r.data);
            this.setState({fileDetails: Array.isArray(data) ? data : []});
        } catch (e) {
            // keep existing fileDetails
        }
    }

    openEditWorkReport = (record) => {
        this.setState({
            show: true,
            reportType: 'workReport',
            editingWorkReport: record,
            dateValues: {
                ...this.state.dateValues,
                workReportDate: record.date || '',
            },
        });
    }

    datePart = (value) => {
        if (value == null || value === '') return '';
        return String(value).split(' ')[0];
    }

    buildEditDraft = (person = {}) => ({
        firstName: person.firstName || '',
        lastName: person.lastName || '',
        nationalCode: person.nationalCode || '',
        certificateNumber: person.certificateNumber || '',
        placeOfIssue: person.placeOfIssue || '',
        birthDate: this.datePart(person.birthDate),
        nationality: person.nationality || '',
        fatherName: person.fatherName || '',
        religion: person.religion || '',
        subReligion: person.subReligion || '',
        university: person.university || '',
        education: person.education || '',
        studentNumber: person.studentNumber || '',
        major: person.major || '',
        fatherJob: person.fatherJob || '',
        maritalStatus: person.maritalStatus || '',
        spouseFullName: person.spouseFullName || '',
        spouseFatherName: person.spouseFatherName || '',
        spouseJob: person.spouseJob || '',
        health: person.health === true ? 'true' : person.health === false ? 'false' : '',
        healthyStatus: person.healthyStatus || '',
        phoneNumber: person.phoneNumber || '',
        telephoneNumber: person.telephoneNumber || '',
        emergencyNumber: person.emergencyNumber || '',
        address: person.address || '',
        postalCode: person.postalCode || '',
        email: person.email || '',
        job: person.job || '',
        gender: person.gender || '',
        startDate: this.datePart(person.timePeriod?.startDate || person.startDate),
        endDate: this.datePart(person.timePeriod?.endDate || person.endDate),
        depositReturnDate: person.depositReturnDate || '',
        paymentDate: this.datePart(person.paymentDate),
        rentPaymentAmount: person.rentPaymentAmount || '',
        depositPaymentAmount: person.depositPaymentAmount || '',
        discountPaymentAmount: person.discountPaymentAmount || '',
        relationshipWithResident: person.relationshipWithResident || '',
        firstPersonFullName: person.firstPersonFullName || '',
        firstPersonPhoneNumber: person.firstPersonPhoneNumber || '',
        firstPersonFatherName: person.firstPersonFatherName || '',
        firstPersonRelationshipWithResident: person.firstPersonRelationshipWithResident || '',
        secondPersonFullName: person.secondPersonFullName || '',
        secondPersonPhoneNumber: person.secondPersonPhoneNumber || '',
        secondPersonFatherName: person.secondPersonFatherName || '',
        secondPersonRelationshipWithResident: person.secondPersonRelationshipWithResident || '',
    })

    renderPersonEditFields = () => {
        const personType = this.state.person?.personType || 'constant';
        const draft = this.state.editDraft || {};
        const setField = (field, value) => this.setState({
            editDraft: {...this.state.editDraft, [field]: value},
        });
        const textField = (field, label) => (
            <div className="col-12 col-md-4" key={field}>
                <label className="form-label small">{label}</label>
                <input className="form-control form-control-sm"
                       value={draft[field] || ''}
                       onChange={(e) => setField(field, e.target.value)}/>
            </div>
        );
        const selectField = (field, label, options) => (
            <div className="col-12 col-md-4" key={field}>
                <label className="form-label small">{label}</label>
                <select className="form-select form-select-sm"
                        value={draft[field] || ''}
                        onChange={(e) => setField(field, e.target.value)}>
                    <option value="">—</option>
                    {options.map((o) => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                </select>
            </div>
        );
        const relationOptions = [
            {value: 'father', label: 'پدر'},
            {value: 'mother', label: 'مادر'},
            {value: 'sister', label: 'خواهر'},
            {value: 'brother', label: 'برادر'},
            {value: 'other', label: 'غیره'},
        ];

        if (personType === 'familyGuest' || personType === 'otherGuest') {
            return (
                <div className="row g-2">
                    {textField('firstName', 'نام')}
                    {textField('lastName', 'نام خانوادگی')}
                    {textField('nationalCode', 'کد ملی')}
                    {textField('certificateNumber', 'شماره شناسنامه')}
                    {textField('fatherName', 'نام پدر')}
                    {textField('placeOfIssue', 'محل صدور')}
                    {textField('birthDate', 'تاریخ تولد')}
                    {textField('startDate', 'تاریخ شروع پذیرش')}
                    {textField('endDate', 'تاریخ اتمام پذیرش')}
                    {textField('paymentDate', 'تاریخ پرداخت')}
                    {textField('rentPaymentAmount', 'مبلغ اجاره')}
                    {textField('depositPaymentAmount', 'مبلغ ودیعه')}
                    {textField('discountPaymentAmount', 'مبلغ تخفیف')}
                    {textField('depositReturnDate', 'تاریخ عودت ودیعه')}
                    {textField('phoneNumber', 'همراه')}
                    {textField('telephoneNumber', 'تلفن منزل')}
                    {textField('address', 'آدرس')}
                    {personType === 'familyGuest'
                        ? selectField('relationshipWithResident', 'نسبت با اقامتگر', relationOptions)
                        : null}
                </div>
            );
        }

        return (
            <>
                <h6 className="mb-2">اطلاعات فردی</h6>
                <div className="row g-2">
                    {textField('firstName', 'نام')}
                    {textField('lastName', 'نام خانوادگی')}
                    {textField('nationalCode', 'کد ملی')}
                    {textField('certificateNumber', 'شماره شناسنامه')}
                    {textField('placeOfIssue', 'محل صدور')}
                    {textField('birthDate', 'تاریخ تولد')}
                    {textField('nationality', 'ملیت')}
                    {textField('fatherName', 'نام پدر')}
                    {selectField('religion', 'دین', [
                        {value: 'islam', label: 'اسلام'},
                        {value: 'christianity', label: 'مسیحیت'},
                        {value: 'hinduism', label: 'هندوئیسم'},
                        {value: 'buddhism', label: 'آیین بودایی'},
                        {value: 'other', label: 'سایر'},
                    ])}
                    {textField('subReligion', 'مذهب')}
                    {textField('university', 'دانشگاه محل تحصیل')}
                    {textField('education', 'تحصیلات')}
                    {textField('studentNumber', 'شماره دانشجویی')}
                    {textField('major', 'رشته تحصیلی')}
                    {textField('fatherJob', 'شغل پدر')}
                    {textField('job', 'شغل')}
                    {selectField('maritalStatus', 'وضعیت تاهل', [
                        {value: 'single', label: 'مجرد'},
                        {value: 'married', label: 'متاهل'},
                        {value: 'divorced', label: 'مطلقه'},
                        {value: 'widowed', label: 'بیوه'},
                        {value: 'separated', label: 'متارکه'},
                    ])}
                    {draft.maritalStatus === 'married' ? (
                        <>
                            {textField('spouseFullName', 'نام و نام خانوادگی همسر')}
                            {textField('spouseFatherName', 'نام پدر همسر')}
                            {textField('spouseJob', 'شغل همسر')}
                        </>
                    ) : null}
                    {selectField('health', 'بیماری خاص', [
                        {value: 'true', label: 'بله'},
                        {value: 'false', label: 'خیر'},
                    ])}
                    {draft.health === 'true' ? textField('healthyStatus', 'توضیحات بیماری') : null}
                    {textField('phoneNumber', 'شماره همراه اقامتگر')}
                    {textField('telephoneNumber', 'شماره تلفن منزل')}
                    {textField('emergencyNumber', 'شماره اضطراری')}
                    {textField('startDate', 'تاریخ شروع پذیرش')}
                    {textField('endDate', 'تاریخ اتمام پذیرش')}
                    {textField('depositReturnDate', 'تاریخ عودت ودیعه')}
                    {textField('address', 'آدرس محل سکونت')}
                    {textField('postalCode', 'کد پستی')}
                    {textField('email', 'ایمیل')}
                    {selectField('gender', 'جنسیت', [
                        {value: 'male', label: 'مرد'},
                        {value: 'female', label: 'زن'},
                    ])}
                </div>
                <h6 className="mt-4 mb-2">بستگان — شخص اول</h6>
                <div className="row g-2">
                    {textField('firstPersonFullName', 'نام و نام خانوادگی')}
                    {textField('firstPersonPhoneNumber', 'شماره تماس')}
                    {textField('firstPersonFatherName', 'نام پدر')}
                    {selectField('firstPersonRelationshipWithResident', 'نسبت با اقامتگر', relationOptions)}
                </div>
                <h6 className="mt-4 mb-2">بستگان — شخص دوم</h6>
                <div className="row g-2">
                    {textField('secondPersonFullName', 'نام و نام خانوادگی')}
                    {textField('secondPersonPhoneNumber', 'شماره تماس')}
                    {textField('secondPersonFatherName', 'نام پدر')}
                    {selectField('secondPersonRelationshipWithResident', 'نسبت با اقامتگر', relationOptions)}
                </div>
            </>
        );
    }

    openExtendBedModal = () => {
        const endRaw = this.state.person?.timePeriod?.endDate;
        const dateStr = endRaw ? String(endRaw).split(' ')[0] : '';
        this.setState({showExtendBedModal: true, extendBedDateDraft: dateStr});
    }

    closeExtendBedModal = () => {
        this.setState({showExtendBedModal: false, extendBedDateDraft: '', extendBedSaving: false});
    }

    savePersonEdit = async () => {
        const charId = this.state.person?.id;
        if (!charId) return;
        this.setState({editSaving: true});
        const draft = {...this.state.editDraft};
        const payload = {...draft};

        // Backend expects flat startDate/endDate (not nested timePeriod)
        payload.startDate = draft.startDate || null;
        payload.endDate = draft.endDate || null;
        if (draft.health === 'true') payload.health = true;
        else if (draft.health === 'false') payload.health = false;
        else payload.health = null;

        // Avoid sending empty enums that break valueOf on the server
        ['maritalStatus', 'gender', 'religion', 'registrationType'].forEach((key) => {
            if (payload[key] === '') payload[key] = null;
        });

        try {
            await axios.put(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, payload, {
                headers: {'Authorization': localStorage.getItem('accessToken')}
            });
            const person = {
                ...this.state.person,
                ...payload,
                health: payload.health,
                timePeriod: {
                    ...(this.state.person.timePeriod || {}),
                    startDate: draft.startDate || this.state.person.timePeriod?.startDate,
                    endDate: draft.endDate || this.state.person.timePeriod?.endDate,
                },
            };
            this.setState({
                person,
                editMode: false,
                editSaving: false,
                editDraft: this.buildEditDraft(person),
            });
            window.alert('مشخصات ذخیره شد');
        } catch (e) {
            this.setState({editSaving: false});
            window.alert('ذخیره مشخصات ناموفق بود');
        }
    }

    describeUploadError = (err, file) => {
        const status = err?.response?.status;
        const apiMsg = err?.response?.data?.message?.Message
            || err?.response?.data?.message?.['Message:']
            || err?.response?.data?.message
            || err?.message;
        const sizeMb = file ? (file.size / (1024 * 1024)).toFixed(1) : null;

        if (status === 413 || (typeof apiMsg === 'string' && /too large|File too large/i.test(apiMsg))) {
            return `حجم فایل زیاد است${sizeMb ? ` (${sizeMb} مگابایت)` : ''}. حداکثر مجاز ۵۰ مگابایت است؛ فایل را فشرده کنید یا با کیفیت پایین‌تر اسکن کنید.`;
        }
        if (status === 417) {
            return `سرور فایل را نپذیرفت${sizeMb ? ` (حجم ${sizeMb} مگابایت)` : ''}. اگر اسکنر است، به JPG/PNG تبدیل کنید یا حجم را کم کنید.`;
        }
        if (status === 401 || status === 403) {
            return 'نشست منقضی شده؛ دوباره وارد شوید و مجدداً آپلود کنید.';
        }
        if (status === 400) {
            return 'درخواست نامعتبر بود. فرمت فایل را به JPG، PNG یا PDF تغییر دهید و دوباره تلاش کنید.';
        }
        if (!err?.response) {
            return 'ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید.';
        }
        if (typeof apiMsg === 'string' && apiMsg && apiMsg !== 'no file id') {
            return `آپلود ناموفق بود: ${apiMsg}`;
        }
        return `آپلود تعهدنامه ناموفق بود${status ? ` (کد ${status})` : ''}${sizeMb ? ` — حجم فایل ${sizeMb} مگابایت` : ''}. فرمت JPG/PNG/PDF و حجم زیر ۲۰ مگابایت را امتحان کنید.`;
    }

    syncDocFlags = (docFile = {}) => {
        this.setState({
            hasBirthPage1: !!docFile.birthPage1,
            hasBirthPage2: !!docFile.birthPage2,
            hasBirthPage3: !!docFile.birthPage3,
            hasBirthPage4: !!docFile.birthPage4,
            hasBirthAllPage: !!docFile.birthAllPage,
            hasCartPage1: !!docFile.cardPage1,
            hasCartPage2: !!docFile.cardPage2,
            hasCartAllPage: !!docFile.cardAllPage,
            hasPersonnelImg: !!docFile.personnelImg,
            hasRegister: !!docFile.register,
            hasRegisterUni: !!docFile.registerUni,
            hasCommitmentLetter: !!docFile.commitmentLetter,
        });
    }

    renderPersonDocRow = (docKey, label) => {
        const fileId = this.state.docFile?.[docKey];
        const busy = this.state.docUploadLoadingKey === docKey;
        const accept = 'image/jpeg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.pdf,application/pdf';
        return (
            <div key={docKey} className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2 p-2 border rounded">
                <div className="ms-1">{label}</div>
                <div className="d-flex flex-wrap gap-1 align-items-center">
                    {fileId ? (
                        <>
                            <button type="button" className="btn btn-sm btn-outline-secondary"
                                    disabled={busy}
                                    onClick={() => this.downloadFile(fileId)}>
                                دانلود
                            </button>
                            <label className="btn btn-sm btn-outline-primary mb-0">
                                ویرایش
                                <input
                                    type="file"
                                    hidden
                                    accept={accept}
                                    disabled={busy}
                                    onChange={(e) => this.uploadPersonDocument(docKey, e)}
                                />
                            </label>
                            <button type="button" className="btn btn-sm btn-outline-danger"
                                    disabled={busy}
                                    onClick={() => this.deletePersonDocument(docKey, fileId)}>
                                حذف
                            </button>
                        </>
                    ) : (
                        <label className="btn btn-sm btn-outline-success mb-0">
                            آپلود
                            <input
                                type="file"
                                hidden
                                accept={accept}
                                disabled={busy}
                                onChange={(e) => this.uploadPersonDocument(docKey, e)}
                            />
                        </label>
                    )}
                    {busy ? <span className="text-muted small">در حال انجام...</span> : null}
                </div>
            </div>
        );
    }

    validatePersonUploadFile = (file) => {
        if (!file) return 'فایلی انتخاب نشده است.';
        const maxBytes = 50 * 1024 * 1024;
        if (file.size > maxBytes) {
            return `حجم فایل ${(file.size / (1024 * 1024)).toFixed(1)} مگابایت است و از حد مجاز ۵۰ مگابایت بیشتر است.`;
        }
        const allowed = /image\/|application\/pdf|\.jpe?g$|\.png$|\.gif$|\.webp$|\.pdf$/i;
        const typeOrName = `${file.type || ''} ${file.name || ''}`;
        if (file.type && !allowed.test(typeOrName) && !/\.jpe?g$/i.test(file.name || '')) {
            return 'فرمت فایل پشتیبانی نمی‌شود. از JPG، PNG یا PDF استفاده کنید.';
        }
        return '';
    }

    refreshAccessTokenIfNeeded = async (err) => {
        if (err?.response?.status !== 401 && err?.response?.status !== 403) {
            throw err;
        }
        const role = localStorage.getItem('role');
        const refreshUrl = role === 'MANAGER'
            ? `${API_BASE_URL}/api/v1/manager/token/refresh`
            : `${API_BASE_URL}/api/v1/supervisor/token/refresh`;
        const refreshed = await axios.get(refreshUrl, {
            headers: {'Authorization': localStorage.getItem('refreshToken')}
        });
        if (!refreshed.headers['accesstoken']) {
            window.location = '/';
            return false;
        }
        localStorage.setItem('accessToken', refreshed.headers['accesstoken']);
        return true;
    }

    linkPersonFile = (personId, docKey, fileId) => axios.put(
        `${API_BASE_URL}/api/v1/supervisor/person/${personId}`,
        {files: [{name: docKey, fileId}]},
        {headers: {'Authorization': localStorage.getItem('accessToken')}}
    );

    uploadPersonDocument = async (docKey, e) => {
        const file = e?.target?.files?.[0];
        if (!file) return;
        const personId = this.state.personObject?.id;
        if (!personId) {
            window.alert('شناسه شخص یافت نشد');
            return;
        }
        const invalid = this.validatePersonUploadFile(file);
        if (invalid) {
            window.alert(invalid);
            if (e?.target) e.target.value = '';
            return;
        }

        const isCommitment = docKey === 'commitmentLetter';
        this.setState(isCommitment
            ? {commitmentUploadLoading: true}
            : {docUploadLoadingKey: docKey});

        const formData = new FormData();
        formData.append('file', file);
        const postFile = () => axios.post(`${API_BASE_URL}/api/v1/supervisor/file`, formData, {
            headers: {'Authorization': localStorage.getItem('accessToken')},
        }).then(r => r.data);

        try {
            let uploaded;
            try {
                uploaded = await postFile();
            } catch (firstErr) {
                const ok = await this.refreshAccessTokenIfNeeded(firstErr);
                if (ok === false) return;
                uploaded = await postFile();
            }
            const fileId = uploaded?.message?.id || uploaded?.id;
            if (!fileId) {
                throw Object.assign(new Error('شناسه فایل از سرور برنگشت'), {response: {status: 417, data: uploaded}});
            }
            await this.linkPersonFile(personId, docKey, fileId);
            const docFile = {...(this.state.docFile || {}), [docKey]: fileId};
            const prevDetails = Array.isArray(this.state.fileDetails) ? this.state.fileDetails : [];
            const already = prevDetails.some((f) => f.fileId === fileId);
            const nextDetails = already
                ? prevDetails
                : [...prevDetails, {
                    fileId,
                    name: docKey,
                    originalName: file.name || docKey,
                    parentType: 'Person',
                    parentId: personId,
                }];
            this.setState({
                docFile,
                personObject: {...this.state.personObject, files: docFile},
                fileDetails: nextDetails,
                commitmentUploadLoading: false,
                docUploadLoadingKey: '',
            }, () => this.syncDocFlags(docFile));
            await this.refreshFileDetails(personId);
            window.alert(isCommitment ? 'تعهدنامه با موفقیت ذخیره شد' : 'مدرک با موفقیت ذخیره شد');
        } catch (err) {
            this.setState({commitmentUploadLoading: false, docUploadLoadingKey: ''});
            window.alert(this.describeUploadError(err, file));
        }
        if (e?.target) e.target.value = '';
    }

    deletePersonDocument = async (docKey, fileId) => {
        const personId = this.state.personObject?.id;
        if (!personId || !docKey) return;
        if (!window.confirm('این مدرک حذف شود؟')) return;

        this.setState({docUploadLoadingKey: docKey});
        try {
            try {
                await this.linkPersonFile(personId, docKey, '__DELETE__');
            } catch (firstErr) {
                const ok = await this.refreshAccessTokenIfNeeded(firstErr);
                if (ok === false) return;
                await this.linkPersonFile(personId, docKey, '__DELETE__');
            }
            if (fileId) {
                try {
                    await axios.delete(`${API_BASE_URL}/api/v1/supervisor/file/${fileId}`, {
                        headers: {'Authorization': localStorage.getItem('accessToken')},
                    });
                } catch (e) { /* file blob optional */ }
            }
            const details = (this.state.fileDetails || []).filter((f) => !(f.name === docKey && (!fileId || f.fileId === fileId)));
            for (const row of (this.state.fileDetails || [])) {
                if (row.name === docKey && row.id && (!fileId || row.fileId === fileId)) {
                    try {
                        await axios.delete(`${API_BASE_URL}/api/v1/supervisor/responseFile/${row.id}`, {
                            headers: {'Authorization': localStorage.getItem('accessToken')},
                        });
                    } catch (e) { /* ignore */ }
                }
            }
            const docFile = {...(this.state.docFile || {})};
            delete docFile[docKey];
            this.setState({
                docFile,
                personObject: {...this.state.personObject, files: docFile},
                fileDetails: details,
                docUploadLoadingKey: '',
            }, () => this.syncDocFlags(docFile));
            await this.refreshFileDetails(personId);
        } catch (err) {
            this.setState({docUploadLoadingKey: ''});
            window.alert('حذف مدرک ناموفق بود');
        }
    }

    setCurrentCommitment = async (fileId) => {
        const personId = this.state.personObject?.id;
        if (!personId || !fileId) return;
        this.setState({commitmentUploadLoading: true});
        try {
            try {
                await this.linkPersonFile(personId, 'commitmentLetter', fileId);
            } catch (firstErr) {
                const ok = await this.refreshAccessTokenIfNeeded(firstErr);
                if (ok === false) return;
                await this.linkPersonFile(personId, 'commitmentLetter', fileId);
            }
            const docFile = {...(this.state.docFile || {}), commitmentLetter: fileId};
            this.setState({
                docFile,
                hasCommitmentLetter: true,
                personObject: {...this.state.personObject, files: docFile},
                commitmentUploadLoading: false,
            });
        } catch (e) {
            this.setState({commitmentUploadLoading: false});
            window.alert('تنظیم تعهدنامه فعلی ناموفق بود');
        }
    }

    deleteCommitmentEntry = async (item) => {
        const personId = this.state.personObject?.id;
        if (!personId || !item?.fileId) return;
        if (!window.confirm('این تعهدنامه از تاریخچه حذف شود؟')) return;

        const loadingKey = `commitment:${item.fileId}`;
        this.setState({docUploadLoadingKey: loadingKey, commitmentUploadLoading: true});
        try {
            const isCurrent = item.fileId === this.state.docFile?.commitmentLetter;
            if (isCurrent) {
                try {
                    await this.linkPersonFile(personId, 'commitmentLetter', '__DELETE__');
                } catch (firstErr) {
                    const ok = await this.refreshAccessTokenIfNeeded(firstErr);
                    if (ok === false) return;
                    await this.linkPersonFile(personId, 'commitmentLetter', '__DELETE__');
                }
            }
            if (item.id) {
                try {
                    await axios.delete(`${API_BASE_URL}/api/v1/supervisor/responseFile/${item.id}`, {
                        headers: {'Authorization': localStorage.getItem('accessToken')},
                    });
                } catch (e) { /* ignore */ }
            }
            try {
                await axios.delete(`${API_BASE_URL}/api/v1/supervisor/file/${item.fileId}`, {
                    headers: {'Authorization': localStorage.getItem('accessToken')},
                });
            } catch (e) { /* ignore */ }

            const docFile = {...(this.state.docFile || {})};
            if (isCurrent) {
                delete docFile.commitmentLetter;
            }
            const fileDetails = (this.state.fileDetails || []).filter((f) => f.fileId !== item.fileId);
            this.setState({
                docFile,
                fileDetails,
                personObject: {...this.state.personObject, files: docFile},
                hasCommitmentLetter: !!docFile.commitmentLetter,
                commitmentUploadLoading: false,
                docUploadLoadingKey: '',
            });
            await this.refreshFileDetails(personId);
        } catch (e) {
            this.setState({commitmentUploadLoading: false, docUploadLoadingKey: ''});
            window.alert('حذف تعهدنامه ناموفق بود');
        }
    }

    uploadCommitmentLetter = async (e) => {
        await this.uploadPersonDocument('commitmentLetter', e);
    }

    existDocFile = (docFile) => {
        this.syncDocFlags(docFile && typeof docFile === 'object' ? docFile : {});
    }

    extendBedEndDate = async () => {
        const next = (this.state.extendBedDateDraft || '').trim();
        if (!next) {
            window.alert('تاریخ جدید اتمام پذیرش را انتخاب کنید');
            return;
        }
        const charId = this.state.person?.id;
        if (!charId) {
            return;
        }
        this.setState({extendBedSaving: true});
        const payload = {endDate: next};
        const applyLocal = () => {
            const person = {...this.state.person, timePeriod: {...this.state.person.timePeriod, endDate: next}};
            this.setState({person, showExtendBedModal: false, extendBedSaving: false, extendBedDateDraft: ''});
            window.alert('تاریخ اتمام پذیرش تمدید شد');
        };
        await axios.put(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, payload, {headers: {'Authorization': localStorage.getItem('accessToken')}})
            .then(() => applyLocal())
            .catch(async () => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.put(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, payload, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    .then(() => applyLocal())
                            } else {
                                window.location = '/'
                            }
                        })
                } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                    await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.put(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, payload, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    .then(() => applyLocal())
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })
    }
}

export default ProfilePage